{
    "COMMON": {
        "BACK": "Back",
        "BACK_TO_FORM": "Back to form",
        "CONFIRM": "Confirm",
        "SUBMIT": "Submit",
        "CONTINUE": "Continue",
        "SAVE": "Save",
        "APPLY": "Apply",
        "ACCEPT": "Accept",
        "CANCEL": "Cancel",
        "CLEAR": "Clear",
        "ADD": "Add",
        "URL": "URL",
        "SCHEDULED": "Scheduled",
        "CANCEL_BOOKING": "Cancel Booking",
        "REFRESH": "Refresh",
        "CHANGE": "Change",
        "REMOVE": "Remove",
        "RETURN": "Return",
        "FILTERS": "Filters",
        "FILTERS_CLEAR": "Clear Filters",
        "OPTIONS": "Options",
        "COLUMN": "Column",
        "ROW": "Row",
        "ALL": "All",
        "DUPLICATE": "Duplicate",
        "HEIGHT": "Height",
        "WIDTH": "Width",
        "EDIT": "Edit",
        "DELETE": "Delete",
        "TRUE": "Yes",
        "FALSE": "No",
        "NONE": "None",
        "ON": "On",
        "OFF": "Off",
        "DEFAULT": "Default",
        "ENABLED": "Enabled",
        "DISABLED": "Disabled",
        "CODE": "Code",
        "BOOK": "Book",
        "MINUTE": "Minute",
        "HOUR": "Hour",
        "DAY": "Day",
        "WEEK": "Week",
        "MONTH": "Month",
        "YEAR": "Year",
        "CRON_CUSTOM": "Custom",
        "TODAY": "Today",
        "MAP": "Map",
        "LIST": "List",
        "GRID": "Grid",
        "CALENDAR": "Calendar",
        "TYPE": "Type",
        "WEBPAGE": "Webpage",
        "PERSON": "Person",
        "GROUP": "Group",
        "GROUPS": "Groups",
        "STATUS": "Status",
        "PUBLISHED": "Published",
        "RESULTS": "Results",
        "FEATURES": "Features",
        "BOOKABLE": "Bookable",
        "EMPTY": "N/A",
        "LOADING": "Loading",
        "UNKNOWN": "Unknown",
        "NEXT": "Next",
        "PREVIOUS": "Previous",
        "NEXT_PAGE": "Next Page",
        "PREVIOUS_PAGE": "Previous Page",
        "RESULTS_COUNT": "{{ count }} result(s) found",
        "RESULTS_COUNT_1": "{{ count }} result found",
        "RESULTS_COUNT_N": "{{ count }} results found",
        "AVAILABLE_COUNT": "{{ count }} of {{ total }} available",
        "ITEM_COUNT": "{{ count }} items",
        "ITEM_COUNT_1": "{{ count }} item",
        "NO_ITEMS": "No items",
        "VIEW_LIST": "View List",
        "TIME": "Time",
        "TODAY_TIME": "Today, {{ time }}",
        "WEEK_SELECT": "Select week",
        "WEEK_THIS": "This week",
        "WEEK_UPCOMING": "Upcoming week",
        "MONTH_THIS": "This month",
        "MONTH_UPCOMING": "Upcoming month",
        "FAVOURITES": "Favourites",
        "FAVOURITES_ONLY": "Favourites Only",
        "FAVOURITES_ADD": "Add to favourites",
        "FAVOURITES_REMOVE": "Remove from favourites",
        "ACCESSIBLE_ONLY": "Accessible Only",
        "LANGUAGE": "Language",
        "LANGUAGE_SELECT": "Select a language",
        "ALL_DAY": "All Day",
        "CHECK_IN": "Check-in",
        "CHECK_OUT": "Check-out",
        "CHECKED_IN": "Checked-in",
        "CHECKED_IN_NOT": "Not Checked-in",
        "CHECKED_OUT": "Checked-out",
        "CHECKED_IN_AT": "Checked-in at",
        "CHECKED_OUT_AT": "Checked-out at",
        "LOAD_MORE": "Load more",
        "PREVIEW": "Preview",
        "DETAILS": "Details",
        "VIEW": "View",
        "VIEW_ALL": "View All",
        "VIEW_DETAILS": "View Details",
        "VIEW_AS_GRID": "View as Grid",
        "VIEW_AS_LIST": "View as List",
        "PENDING": "Pending",
        "CAPACITY": "Capacity",
        "CAPACITY_EMPTY": "No capacity set",
        "SEARCH": "Search for...",
        "SEARCH_EMPTY": "No matches found.",
        "STATUS_NOT_BOOKABLE": "Not Bookable",
        "STATUS_FREE": "Available",
        "STATUS_PENDING": "Tentative",
        "STATUS_BUSY": "In Use",
        "STATUS_RESERVED": "Reserved",
        "STATE": "State",
        "STATE_DONE": "Done",
        "STATE_IN_PROGRESS": "In Progress",
        "STATE_ACTIVE": "Active",
        "LOCATION": "Location",
        "DESCRIPTION": "Description",
        "DESCRIPTION_EMPTY": "No Description",
        "DESCRIPTION_REQUIRED": "A description is required",
        "ZONE": "Zone",
        "ZONE_ANY": "Any Zone",
        "ZONE_REQUIRED": "A valid zone is required",
        "REQUIRED": "Required",
        "REMOVE_ITEM": "Remove {{ item }}",
        "BOOTSTRAP_DESCRIPTION": "Input the PlaceOS System ID to bootstrap",
        "BOOTSTRAP_LABEL": "System ID",
        "BOOTSTRAP_SUBMIT": "Finish setup",
        "BOOTSTRAP_LOADING": "Loading system data...",
        "BOOTSTRAP_SETUP": "Setup",
        "BOOTSTRAP_ASSISTANT": "Assistant Panel",
        "BOOTSTRAP_ASSISTANT_INFO": "Select the system to connect to for Assistant functionality",
        "BOOTSTRAP_INPUT_PLACEHOLDER": "Start typing to search for a room",
        "CONTROLS_HELP": "Help & Support",
        "CONTROLS_WORK_LOCATION": "Work Location",
        "CONTROLS_ACCESSIBILITY": "Display & Accessibility",
        "CONTROLS_DESKS": "Desk Settings",
        "CONTROLS_PARKING": "Parking Settings",
        "CONTROLS_SUPPORT": "Raise a support ticket",
        "CONTROLS_SIGN_OUT": "Sign Out",
        "CONTROLS_NEW_VERSION": "New Version",
        "CONTROLS_VERSION": "Version",
        "FORBIDDEN": "Access forbidden.",
        "INVALID_PAGE_PERMISSIONS": "You do not have permission to view this page and your access attempt has been recorded.",
        "CONTACT_ADMIN": "Contact your Administrator if you feel that you should have access.",
        "DARK_MODE": "Dark Mode",
        "TEXT_SIZE": "Large Accessibility Sizes",
        "TEXT_SIZE_MSG": "Adjust your preferred reading size below.",
        "BUILDING_SELECT": "Select a building",
        "REGION_SELECT": "Select a region",
        "LEVEL_SELECT": "Select a level",
        "ROOM_SELECT": "Select a room",
        "MISCONFIGURED_TITLE": "Application Misconfigured",
        "MISCONFIGURED_MSG": "This application requires a zone of type org, building and level to operate.",
        "MISCONFIGURED_CONTACT": "If this issue persists please contact your administrator.",
        "LAST_UPDATE": "Last updated",
        "IMAGE": "Image",
        "VIDEO": "Video",
        "IMAGES_EMPTY": "No images",
        "SERVER_DOWN": "Unable to reach server... Some features may not work.",
        "DESK_HEIGHT_TITLE": "Desk Height Presets",
        "DESK_HEIGHT_MSG": "Desk height presets allow you to store and recall your preferred desk height when checking into a booked desk that supports height adjustment.",
        "DESK_HEIGHT_NOT_SET": "Before you can set a desk height, presets must be set",
        "DESK_HEIGHT_INFO": "Set your desk height for the best experience.",
        "DESK_HEIGHT_SITTING": "Sitting Height",
        "DESK_HEIGHT_STANDING": "Standing Height",
        "CONSOLE": "Console",
        "AVAILABILITY": "Availability",
        "SUPPORT_HEADER": "Raise a support ticket",
        "SUPPORT_LOCATION": "Location",
        "SUPPORT_TYPE": "Issue Type",
        "SUPPORT_DESCRIPTION": "Issue Description",
        "SUPPORT_DESCRIPTION_REQUIRED": " A description is required",
        "SUPPORT_IMAGES": "Images",
        "SUPPORT_LOADING": "Sending support ticket...",
        "SUPPORT_MSG": "Completing this form will raise an incident in your support management platform",
        "SUPPORT_NO_MAILER": "Mailing system not configured for application.",
        "SUPPORT_SUCCESS": "Successfully submitted support ticket",
        "SUPPORT_MAIL_HEADER": "Support Ticket from Workplace Application",
        "REMOVE_FROM": "Remove from booking",
        "ADD_TO": "Add to booking",
        "TAGS": "Tags",
        "REGION_ANY": "Any Region",
        "REGION_ALL": "All Regions",
        "BUILDING_ANY": "Any Building",
        "BUILDING_ALL": "All Buildings",
        "LEVEL_ANY": "Any Level",
        "LEVEL_ALL": "All Levels",
        "LEVEL_EMPTY": "No Level",
        "ROOM_EMPTY": "No Room",
        "TYPE_INTERNAL": "Internal",
        "TYPE_EXTERNAL": "External",
        "TYPE_CANCELLED": "Cancelled",
        "APPROVED": "Approved",
        "APPROVE": "Approve",
        "DECLINED": "Declined",
        "DECLINE": "Decline",
        "TIMEZONE": "Timezone",
        "TIMEZONE_EMPTY": "No matching timezones",
        "IMAGES": "Images",
        "IMAGE_ADD_URL": "Add image via URL",
        "IMAGE_UPLOADS": "Upload Image(s)",
        "CATEGORY": "Category",
        "CATEGORY_NEW": "New Category",
        "CATEGORY_REQUIRED": "A category is required",
        "CATEGORY_ALL": "All Categories",
        "CATEGORIES": "Categories",
        "TRIGGER": "Trigger",
        "TRIGGER_SELECT": "Select a trigger",
        "TRIGGER_EMPTY": "No trigger",
        "BUILDING_EMPTY": "No building",
        "BUILDING_REQUIRED": "A building is required",
        "CREATED_AT": "Created",
        "DATE_EMPTY": "No date",
        "WORK_LOCATION": "Work Location",
        "WORK_LOCATION_SETTINGS": "Work Location Settings",
        "WORK_LOCATION_EDIT": "Edit Work Location Preferences",
        "WORK_LOCATION_EDIT_INFO": " Click the edit button on the top right to edit your work location preferences.",
        "WORK_LOCATION_EMPTY": "No set work location for today",
        "WORK_SETTINGS_EMPTY": "No working days are currently set for this user",
        "WORK_SETTINGS_SAVE": " Saving changes to work location settings...",
        "WORK_HOURS_OUTSIDE": "Outside of working hours",
        "WORK_HOURS_HOME": "Working from Home",
        "WORK_HOURS_OFFICE": "Working from Office",
        "WORK_HOURS_OUT": "Out of Office",
        "WORK_HOURS_LEAVE": "Away on Leave",
        "WORK_HOME": "Home",
        "WORK_OFFICE": "Office",
        "WORK_LEAVE": "Leave",
        "WORK_DAYS": "Working Days",
        "WORK_HOURS": "Working Hours",
        "TIME_SECOND": "{{ seconds }} minute",
        "TIME_SECONDS": "{{ seconds }} minutes",
        "TIME_MINUTE": "{{ minutes }} minute",
        "TIME_MINUTES": "{{ minutes }} minutes",
        "TIME_HOUR": "{{ hours }} hour",
        "TIME_HOURS": "{{ hours }} hours",
        "TIME_DAY": "{{ days }} day",
        "TIME_DAYS": "{{ days }} days",
        "NOT_IMPLEMENTED": "Not implemented yet",
        "SELECT_USER_TITLE": "Select a user",
        "SELECT_USER_SEARCH": "Search for users...",
        "SELECT_USER_EMPTY": "Start typing to search for users.",
        "SELECT_USER_EMPTY_MATCHES": "No matching users found.",
        "USER_NEW": "New External User",
        "USER_EDIT": "Edit External User",
        "USER_SAVING": "Saving user...",
        "ORGANISATION": "Organisation",
        "APPROVAL": "Approval",
        "APPROVAL_REQUIRED": "Approval Required",
        "REQUIRE_APPROVAL": "Bookings require approval",
        "WFO": "Work from Office",
        "WFH": "Work from Home",
        "AOL": "Away on Leave",
        "END_OF_LIST": "End of list",
        "NO_DESCRIPTION": "No description",
        "VALID_UNTIL": "Valid until",
        "VALID_UNTIL_DATE": "Valid until {{ date }}",
        "TERMS": "Terms & Conditions",
        "LOCATABLE": "Location tracking",
        "UPLOAD_IMAGE": "Upload Image",
        "UPLOAD_IMAGE_INFO": "Drag & Drop or click to upload an image",
        "BOOKED_BY": "Booked By",
        "VISIBILITY": "Visibility",
        "VISIBILITY_NORMAL": "Normal",
        "VISIBILITY_PERSONAL": "Personal",
        "VISIBILITY_PUBLIC": "Public",
        "VISIBILITY_PRIVATE": "Private",
        "VISIBILITY_CONFIDENTIAL": "Confidential",
        "PARKING_SETTINGS_SAVE": "Successfully saved parking settings",
        "MODULE": "Module",
        "ITEM_PRICE": "Price",
        "ROOM_BOOKING_URL": "Room Booking URL",
        "TIMETABLE_URL": "Timetable URL",
        "SUPPORT_URL": "Support URL",
        "URL_VALID": "URL is invalid",
        "PEOPLE_COUNT": "{{ count }} people",
        "PEOPLE_COUNT_1": "{{ count }} person"
    },
    "LANGUAGE": {
        "ENGLISH": "English",
        "ENGLISH_US": "English (US)",
        "ENGLISH_GB": "English (British)",
        "FRENCH": "French",
        "FRENCH_CA": "French (Canadian)",
        "SPANISH": "Spanish",
        "PORTUGUESE": "Portuguese",
        "ITALIAN": "Italian",
        "CHINESE": "Chinese",
        "ARABIC": "Arabic",
        "JAPANESE": "Japanese"
    },
    "RESOURCE": {
        "ROOM": "Room",
        "ROOMS": "Rooms",
        "DESK": "Desk",
        "DESKS": "Desks",
        "PARKING": "Parking",
        "PARKING_SPACE": "Parking space",
        "PARKING_SPACES": "Parking spaces",
        "LOCKER": "Locker",
        "LOCKERS": "Lockers",
        "VISITOR": "Visitor",
        "VISITORS": "Visitors",
        "EVENT": "Event",
        "EVENTS": "Events",
        "CATERING": "Catering",
        "ASSET": "Asset",
        "ASSETS": "Assets",
        "BUILDING": "Building",
        "BUILDINGS": "Buildings",
        "REGION": "Region",
        "REGIONS": "Regions",
        "LEVEL": "Level",
        "LEVELS": "Levels",
        "BOOKING": "Booking",
        "BOOKINGS": "Bookings",
        "ZONE": "Zone",
        "ZONE_ALL": "All Zones",
        "REQUIRE_NOTES": "Require notes for orders",
        "RULESET_HEADER": "Edit {{ name }} Configuration",
        "RULESET_NEW": "New Ruleset",
        "RULESET_ADD_RULE": "Add Rule",
        "RULESET_SHOW_RULES": "Show Rules",
        "RULESET_HIDE_RULES": "Hide Rules",
        "RULESET_REMOVE_RULES": "Remove Rule",
        "RULESET_NAME_REQUIRED": "A ruleset name is required",
        "RULESET_VALUE_REQUIRED": "A rule value is required"
    },
    "FORM": {
        "INVALID_FIELDS": "Some fields are invalid. [{{ field_list }}]",
        "DISPLAY_NAME": "Display Name",
        "NAME": "Name",
        "NAME_REQUIRED": "A valid name is required",
        "EMAIL": "Email",
        "EMAIL_REQUIRED": "A valid email address is required",
        "PHONE": "Phone Number",
        "DATE": "Date",
        "PERIOD": "Period",
        "DATE_END": "End Date",
        "DATE_EMPTY": "No date selected",
        "DATE_ERROR": "Date and time must be in the future",
        "TIME_START": "Start time",
        "TIME_END": "End time",
        "USER_SEARCH": "Search for user...",
        "USER_ADD_EXTERNAL": "Add external attendee \"{{ name }}\" ",
        "USER_EMPTY": "No users found.",
        "USER_LIST_PLACEHOLDER": "Type a name or email",
        "USER_LIST_ADD_EXTERNAL": "Add external user with email \"{{ email }}\"",
        "USER_BTN_ADD_EXTERNAL": "Add External",
        "USER_BTN_ADD_EXTERNAL_SIMPLE": "Add",
        "USER_BTN_UPLOAD": "Upload CSV",
        "USER_BTN_UPLOAD_SIMPLE": "Upload",
        "USER_BTN_TEMPLATE": "CSV Template",
        "USER_BTN_TEMPLATE_SIMPLE": "Template",
        "TITLE": "Title",
        "TITLE_REQUIRED": "A valid title is required",
        "HOST": "Host",
        "TIME": "Time",
        "EXPIRES_AT": "Valid Until",
        "DURATION": "Duration",
        "CLEAR": "Clear form",
        "RESET": "Reset form",
        "NOTES": "Notes",
        "IMAGE": "Image",
        "RECURRENCE": "Recurrence",
        "RECURRENCE_REPEAT_EVERY": "Repeat Every",
        "RECURRENCE_REPEAT_ON": "Repeat on",
        "RECURRENCE_ENDS": "Ends",
        "RECURRENCE_ENDS_NEVER": "Never",
        "RECURRENCE_ENDS_ON": "On",
        "RECURRENCE_ENDS_AFTER": "After",
        "RECURRENCE_NONE": "Doesn't repeat",
        "RECURRENCE_DAILY": "Daily",
        "RECURRENCE_WEEKLY_ON": "Weekly on {{ day }}",
        "RECURRENCE_MONTH_INSTANCE": "{{ index }} {{ day }} of the month",
        "RECURRENCE_CUSTOM": "Custom...",
        "RECURRENCE_CUSTOM_HEADER": "Custom Recurrence",
        "RECURRENCE_DAY": "Day",
        "RECURRENCE_DAYS": "Days",
        "RECURRENCE_WEEK": "Week",
        "RECURRENCE_WEEKS": "Weeks",
        "RECURRENCE_MONTH": "Month",
        "RECURRENCE_MONTHS": "Months",
        "UPDATE_FUTURE": "Update all future events",
        "ASSETS_REQUESTED_FOR": "Request for {{ time }}",
        "ASSETS_REQUESTED_FOR_DATE": "Request for {{ date }} at {{ time }}",
        "ASSETS_DUPLICATE": "Duplicate Request",
        "ASSETS_EDIT": "Edit Request",
        "ASSETS_ADD": "Request Assets",
        "ASSETS_REMOVE": "Remove Assets",
        "ASSETS_REMOVE_ITEM": "Remove requested item",
        "ASSETS_HIDE": "Hide requested items",
        "ASSETS_SHOW": "Show requested items",
        "ASSETS_CLASH_ERROR": "Some of the items are not available for the selected date and time.",
        "ASSETS_TIME_ERROR": "Delivery time is outside of the event time.\nThis order will be ignored.",
        "ASSETS_QUANTITY_ERROR": "Not enough assets available to meet request [{{ name }}].\nAnother request for this asset has been made in this meeting."
    },
    "EXPLORE": {
        "AREAS": "Areas",
        "LEGEND": "Legend",
        "LOCATE_USER": "{{ name }} is here",
        "LOCATE_FAILED": "Failed to locate \"{{ name }}\"",
        "LOCATE_ROUTE_FAILED": "Failed to load direction. Error: {{ error }}",
        "LOCATE_ORIGIN_ERROR": "Origin location is outside of map area.",
        "LOCATE_CURRENT_FAILED": "Failed to retrieve your current location.",
        "LOCATE_USER_FAILED": "Failed to locate user \"{{ name }}\".",
        "LOCATE_USER_NOT_FOUND": "No location for the given user",
        "LOCATE_USER_FOUND_NO_PIN": "User is on this level but with an inaccurate method. {{ type }}",
        "LOCATE_USER_DETAILS_FAILED": "Failed to find user details for \"{{ name }}\".",
        "LOCATE_SPACE_DETAILS_FAILED": "Failed to find space details.",
        "LOCATE_SERVICE_UNAVAILABLE": "Location services is not set up for this application.",
        "ZOOM_IN": "Zoom in",
        "ZOOM_OUT": "Zoom out",
        "ZOOM_RESET": "Reset zoom & centre",
        "DEVICE_COUNT": "{{ count }} user device(s)",
        "SENSORS_TEMP": "Temperature: {{ value }}",
        "SENSORS_PEOPLE": "{{ count }} people",
        "SENSORS_HUMIDITY": "Humidity: {{ value }}",
        "SENSORS_QUEUE": "Queue Size: {{ value }}",
        "SENSORS_COUNT": "Count: {{ value }}",
        "SPACES_PERMISSIONS_ERROR": "You do not have permission to book this space at this time.",
        "SPACES_UNAVAILABLE_ERROR": "{{ name }}  is unavailable for the selected time and duration",
        "PARKING_PERMISSIONS_ERROR": "Your user account has been denied parking access to {{ name }}",
        "PARKING_ASSIGNED_ERROR": "You are already assigned to parking space \"{{ name }}\"",
        "PARKING_EXISTING_ERROR": "You already have a parking space booked for the selected time.",
        "PARKING_AVAILABLE_ERROR": "{{ name }} is unavailable at this time.",
        "PARKING_GROUP_ERROR": "You are not allowed to book \"{{ name }}\"",
        "PARKING_BOOKING_ERROR": "Failed to book parking space \"{{ name }}\". Error: {{ error }}",
        "PARKING_BOOKING_SUCCESS": "Successfully booked parking space \"{{ name }}\".",
        "PARKING_PLATE_NUMBER": "Plate Number",
        "LOCKERS_USE": "{{ used }} lockers in use of {{ count }}",
        "DEVICE_MAC": "MAC",
        "DEVICE_ACCURACY": "Accuracy",
        "DEVICE_LAST_SEEN": "Last Seen",
        "DEVICE_MANUFACTURER": "Manufacturer",
        "DEVICE_OS": "OS",
        "DEVICE_SSID": "SSID",
        "DEVICE_USERNAME": "Username",
        "DEVICE_TYPE": "Type",
        "DESK_AVAILABLE_ERROR": "{{ name }} is unavailable at this time.",
        "DESK_GROUP_ERROR": "You are not allowed to book \"{{ name }}\"",
        "DESK_RESTRICTION_ERROR": "You are not allowed to book \"{{ name }}\"",
        "DESK_BOOKING_ERROR": "Failed to book desk \"{{ name }}\". Error: {{ error }}",
        "DESK_BOOKING_SUCCESS": "Successfully booked desk \"{{ name }}\".",
        "BOOKING_HEADER": "New booking",
        "BOOKING_TITLE_REQUIRED": "Booking title is required",
        "BOOKING_SPACE": "Space",
        "BOOKING_SUCCESS": "Successfully booked room.",
        "BOOK_RESOURCE": "Book - {{ name }}",
        "MAPSINDOORS_INIT_FAILED": "Failed to initialise map view.",
        "MAP_EMPTY": "No map is set to display",
        "MAP_FAILED_TO_LOAD": "Failed to load map",
        "COORDINATES": "Coordinates",
        "MAP_ID": "Map ID",
        "MAP_ID_EMPTY": "No map ID",
        "MAP_ID_REQUIRED": "A valid map ID is required",
        "MAP_ID_PLACEHOLDER": "Element selector within map SVG. e.g. area-01.123-status"
    },
    "BOOKINGS": {
        "ASSOCIATE": "Associate",
        "EVENT": "Event",
        "PREVENT": "Prevent Bookings",
        "RESERVED": "Reserved",
        "RELEASED": "Released",
        "DETAILS": "Details",
        "LOCATION": "Location",
        "ASSETS_HEADER": "Assets",
        "ASSETS_REQUESTED_FOR": "Requested for {{ time }}",
        "ACTION_EDIT": "Edit booking",
        "ACTION_DELETE": "Delete booking",
        "ACTION_PRINT": "Print booking",
        "ACTION_END": "End booking",
        "ACTION_SET_DESK_HEIGHT": "Set Desk Height",
        "ACTION_DELETE_SERIES": "Delete series",
        "CHECK_IN_ERROR": "Failed to check-in booking.",
        "CHECK_IN_SUCCESS": "Successfully checked-in booking.",
        "CHECK_OUT_ERROR": "Failed to check-out booking.",
        "CHECK_OUT_SUCCESS": "Successfully ended booking.",
        "PREVENT_INFO": "Prevent user from booking the resource if the conditions match",
        "AUTO_APPROVE": "Auto-approve Bookings",
        "AUTO_APPROVE_INFO": "Whether resource should be auto-approved when booking if the conditions match",
        "CONDITIONS": "Rule Conditions",
        "CONDITIONS_PLACEHOLDER": "No conditions. Match all resources in zone",
        "CONDITION_GROUPS": "Groups",
        "CONDITION_LOCATION": "Locations",
        "CONDITION_MIN_LENGTH": "Minimum Length",
        "CONDITION_MAX_LENGTH": "Maximum Length",
        "CONDITION_WITHIN": "Is within days",
        "CONDITION_AFTER": "Is after days",
        "CONDITION_BETWEEN_HOURS": "Is between hours",
        "CONDITION_BETWEEN_DATES": "Is between dates",
        "CONDITION_RESOURCES": "Resources",
        "CONDITION_TAGS": "Tags",
        "GROUPS": "User groups",
        "GROUPS_ALLOW": "Allow booking for groups",
        "GROUPS_DENY": "Prevent booking for groups",
        "MIN_LENGTH_ALLOW": "Allow booking with a minimum length of",
        "MIN_LENGTH_DENY": "Prevent booking with a minimum length of",
        "MAX_LENGTH_ALLOW": "Allow booking with a maximum length of",
        "MAX_LENGTH_DENY": "Prevent booking with a maximum length of",
        "BEFORE_ALLOW": "Allow booking before",
        "BEFORE_DENY": "Prevent booking before",
        "BEFORE_REQUIRED": "A valid time is required",
        "AFTER_ALLOW": "Allow booking after",
        "AFTER_DENY": "Prevent booking after",
        "AFTER_REQUIRED": "A valid time is required",
        "BETWEEN_DATES_ALLOW": "Allow booking between dates",
        "BETWEEN_DATES_DENY": "Prevent booking between dates",
        "BETWEEN_HOURS_ALLOW": "Allow booking between",
        "BETWEEN_HOURS_DENY": "Prevent booking between",
        "BETWEEN_HOURS_REQUIRED": "A valid end time is required",
        "RESOURCES_ALLOW": "Allow booking these resources",
        "RESOURCES_DENY": "Prevent booking these resources",
        "RESOURCES_PLACEHOLDER": "Resource IDs",
        "DESKS_LOADING": "Loading desks...",
        "PARKING_LOADING": "Loading parking spaces...",
        "LOCKERS_LOADING": "Loading lockers...",
        "LOADING_AVAILABILITY": "Checking {{ type }} availability...",
        "CONFIRM_TITLE": "Book {{ type }}",
        "CONFIRM_MSG": "Would you like to book the {{ type }} for {{ date }}?",
        "CONFIRM_MSG_GROUP": "Would you like to book the {{ type }} for {{ date }}? <br>Your group members will be assigned desks nearby your selected desk.",
        "CONFIRM_LOADING": "Processing booking request...",
        "ASSETS_CLASH_ERROR": "Some assets are already booked for the selected time",
        "ASSETS_INVALID_ERROR": "Failed to validate asset requests",
        "GROUP_NOT_SET": "No group available to book for.",
        "GROUP_NO_MEMBERS": "No members in your group to book for.",
        "GROUP_SOME_HAVE_BOOKINGS": "Some members of your group already have a desk booking. [{{ members }}]",
        "NO_USER": "No user was selected to book for.",
        "VISITOR_BOOKED": "{{ name }} already has an invite for the selected time.",
        "RESOURCE_BOOKED": "{{ name }} is not available at the selected time",
        "CLASH_CURRENT_USER": "You already have a booking at the selected time",
        "CLASH_OTHER_USER": "{{ name }} already has a booking at the selected time",
        "DESK_TITLE": "Book Desk",
        "DESK_CONFIRM": "Confirm Desk",
        "DESK_ADD": "Add Desk",
        "DESK_ADDED_COUNT": "{{ count }} desks(s) added",
        "DESK_EDIT": "Edit Desk",
        "DESK_REMOVE": "Remove Desk",
        "DESK_FIND": "Find Desk",
        "DESK_LONE": "Single",
        "DESK_GROUP": "Group",
        "DESK_COUNT_LONE": "Single desk",
        "DESK_COUNT_GROUP": "Multiple desk",
        "DESK_TITLE_PLACEHOLDER": "e.g. Focus Time",
        "DESK_REQUIRE_LOCKER": "Require locker",
        "DESK_GROUP_MEMBERS": "Group Members",
        "DESK_GROUP_INFO": "Desks nearby to the selected desk will booked for group members",
        "DESK_ASSETS_REQUESTED": "Requested assets",
        "DESK_LOCKER_REQUESTED": "Requested locker",
        "DESK_AVAILABLE_ERROR": "Desk is unavailable at this time.",
        "DESK_LIST_LOADING": "Finding available desks...",
        "DESK_LIST_EMPTY": "No available desks for selected time and/or filters",
        "DESK_SELECT_MSG": "Select a desk to view its details",
        "ITEM_BOOKED": "{{ name }} booked!",
        "DESK_SUCCESS_LONE": "Your desk booking at {{ location }} has been successfully booked for {{ date }} at {{ time }}",
        "DESK_SUCCESS_GROUP": "Your group of {{ size }} desks at {{ location }} have been successfully booked for {{ date }} at {{ time }}",
        "DESK_SUCCESS_LONE_ALLDAY": "Your desk booking at {{ location }} has been successfully booked for {{ date }}",
        "DESK_SUCCESS_GROUP_ALLDAY": "Your group of {{ size }} desks at {{ location }} have been successfully booked for {{ date }}",
        "ASSETS_BOOKED": "Booking includes {{ count }} asset(s)",
        "SUCCESS_WAIT_APPROVED": "Please allow up to 5 minutes for your booking to be approved.",
        "LINK_HEADER": "Add event to your calendar",
        "LINK_OUTLOOK": "Add to Outlook",
        "LINK_GOOGLE": "Add to Google Calendar",
        "LINK_ICAL": "Download iCal File",
        "LOCKER_TITLE": "Book Locker",
        "LOCKER_CONFIRM": "Confirm Locker",
        "LOCKER_ADD": "Add Locker",
        "LOCKER_EDIT": "Edit Locker",
        "LOCKER_REMOVE": "Remove Locker",
        "LOCKER_FIND": "Find Locker",
        "LOCKER_ADDED_COUNT": "{{ count }} locker(s) added",
        "LOCKER_LIST_LOADING": "Finding available locker banks...",
        "LOCKER_LIST_EMPTY": "No available locker banks for selected time and/or filters",
        "LOCKER_ACCESSIBLE": "Accessible",
        "LOCKER_ACCESSIBLE_SHOW": "Show accessible lockers",
        "PARKING_TITLE": "Book Parking",
        "PARKING_CONFIRM": "Confirm Reservation",
        "PARKING_ADD": "Add Parking Space",
        "PARKING_EDIT": "Edit Parking Space",
        "PARKING_REMOVE": "Remove Parking Space",
        "PARKING_FIND": "Find Parking Space",
        "PARKING_ADDED_COUNT": "{{ count }} bay(s) added",
        "PARKING_PLATE_NUMBER": "Plate Number",
        "PARKING_PLATE_NUMBER_PLACEHOLDER": "e.g. MYPL4T3",
        "PARKING_PLATE_NUMBER_REQUIRED": "A plate number is required",
        "PARKING_LIST_LOADING": "Finding available parking spaces...",
        "PARKING_LIST_EMPTY": "No available parking spaces for selected time and/or filters",
        "PARKING_SELECT_MSG": "Select a parking space to view its details",
        "VISITOR_INVITE_TITLE": "Invite Visitor",
        "VISITOR_LIST": "Visitors",
        "VISITOR_NAME": "Visitor Name",
        "VISITOR_NAME_PLACEHOLDER": "Name of the visitor",
        "VISITOR_EMAIL": "Visitor Email",
        "VISITOR_EMAIL_PLACEHOLDER": "Email of the visitor",
        "VISITOR_COMPANY": "Visitor Company",
        "VISITOR_COMPANY_PLACEHOLDER": "Company of the visitor",
        "VISITOR_REASON": "Reason for visit",
        "VISITOR_REASON_PLACEHOLDER": "e.g. Meeting Catchup",
        "VISITOR_PASS": "Pass Number",
        "VISITOR_PASS_PLACEHOLDER": "e.g. V-1234",
        "VISITOR_SEND": "Send Visitor invite",
        "VISITOR_SENT_SINGLE": "Visitor invite sent to {{ name }}",
        "VISITOR_SENT_MULTIPLE": "Visitor invite sent to {{ count }} people",
        "VISITOR_SENT_MSG": "Invite has been sent to attend {{ location }} from {{ date }} at {{ time }}",
        "VISITOR_SENDING": "Sending out visitor invitations...",
        "VISITOR_BOOK_ANOTHER": "Book another visitor",
        "SPACE_REMOVE": "Remove this space",
        "SPACE_ADD_TO": "Add this space",
        "INDUCTED": "Inducted",
        "PASS_NUMBER": "Pass Number",

        "RECURRING_TOOLTIP": "This booking is part of a recurring series",
        "ASSETS_ADD_HEADER": "Add Assets",
        "ASSETS_ADD": "Add this Asset",
        "ASSETS_REMOVE": "Remove this Asset",
        "ASSETS_SELECT": "Select an asset to view its details",
        "ASSETS_SEARCH": "Search assets...",
        "ASSETS_LOADING": "Finding assets...",
        "ASSETS_EMPTY": "No available assets for selected time and/or filters",
        "ASSETS_DELIVER_TOGGLE": "Exact Time",
        "ASSETS_DELIVER_DATE": "Delivery Date",
        "ASSETS_DELIVER_TIME": "Deliver After",
        "ASSETS_AVAILABLE": "{{ count }} available",
        "RULES_HIDDEN_1": "You are not allowed to book the selected {{ type }} for the selected time or duration",
        "RULES_HIDDEN_N": "You are not allowed to book some of the selected {{ type }}s for the selected time or duration",
        "FIRST_INSTANCE_CLASH": "The first booking in the series clashes with an existing booking",
        "RECURRING_CLASHES_NOT_ALLOWED": "Recurring bookings with {{ count }} clashing instance(s) are not allowed",
        "RECURRING_CLASHES_TITLE": "Booking Clashes Detected",
        "RECURRING_CLASHES_MSG": "Some instances in this recurring booking series clash with existing bookings.",
        "RECURRING_CLASHES_CONFIRM": "These instances will be skipped. Do you want to continue with the booking?",
        "CONTINUE_BOOKING": "Continue Booking"
    },
    "CALENDAR_EVENT": {
        "CATERING": "Catering",
        "CATERING_ORDER_AT_DATE": "Order for {{ date }} at {{ time }}",
        "CATERING_ORDER_AT": "Order at {{ time }}",
        "CATERING_ORDER_DETAILS": "{{ count }} item(s) for {{ cost }}",
        "CATERING_ORDER_SHOW": "Show order items",
        "CATERING_ORDER_HIDE": "Hide order items",
        "CATERING_ORDER_OPTION_COUNT": "{{ count }} option(s)",
        "CATERING_ORDER_DUPLICATE": "Duplicate Order",
        "CATERING_ORDER_EDIT": "Edit Order",
        "CATERING_ORDER_ADD": "Add Order",
        "CATERING_ORDER_ERROR": "Delivery time is outside of the event time.\nThis order will be ignored.",
        "CATERED": "Catered",
        "ATTENDEES_COUNT": "{{ count }} attendees",
        "ATTENDEES_COUNT_1": "{{ count }} attendee",
        "ATTENDEES_COUNT_N": "{{ count }} attendees",
        "ATTENDEE_COUNT": "{{ count }} attendee(s)",
        "ATTENDEES": "Attendees",
        "DETAILS": "Details",
        "NOTES_HEADER": "Notes",
        "ASSETS_HEADER": "Assets",
        "ASSETS_REQUESTED_FOR": "Requested for {{ time }}",
        "ACTION_EDIT": "Edit event",
        "ACTION_DELETE": "Delete event",
        "ACTION_PRINT": "Print event",
        "ACTION_DELETE_SERIES": "Delete series",
        "NO_LONG_EDIT_MSG": "Editing bookings longer than \n a day is not available",
        "SPACE_LOADING": "Loading space list for location...",
        "SPACE_STATUS_LOADING": "Updating available spaces...",
        "SPACE_EXTERNALS_ERROR": "External attendees require a space to be booked",
        "ASSETS_CLASH_ERROR": "Some assets are already booked for the selected time",
        "ASSETS_ERROR": "Failed to book the selected assets.",
        "ASSETS_PARTIAL_ERROR": "Failed to update all asset requests for event.\nError: {{ error }}",
        "ASSETS_INVALID_ERROR": "Failed to validate asset requests",
        "SPACE_UNAVAILABLE": "The selected space is not available at the selected time",
        "SPACES_UNAVAILABLE": "Some of the selected spaces are not available at the selected time",
        "CAPACITY_WARNING": "The selected room has less capacity than the number of meeting attendees.",
        "CAPACITY_ERROR": "Attendee count is greater than the capacity of the selected rooms",
        "CATERING_CHARGE_CODE": "Charge Code",
        "CATERING_CHARGE_CODE_SEARCH": "Search for charge code...",
        "CATERING_CHARGE_CODE_REQUIRED": "Catering charge code is required",
        "CATERING_NOTES": "Extra catering details. e.g. Dietary requirements etc.",
        "CATERING_NOTES_REQUIRED": "Catering order notes are required",
        "NOTES_INFO": "General information for attendees",
        "CONFIRM": "Confirm Meeting",
        "ASSETS_UNAVAILABLE": "Assets are unavailable for some of the selected spaces.",
        "CATERING_UNAVAILABLE": "Catering are unavailable for some of the selected spaces.",
        "DAILY_RECURR_ERROR": "Daily recurrence for all day meetings are not allowed.",
        "ROOM_REQUIRED": "You need to select a room to make a booking",
        "TITLE_PLACEHOLDER": "e.g. Team Meeting",
        "SUCCESS": "Successfully created event",
        "SUCCESS_WITH_SPACE": "You room booking for {{ level }}, {{ space }} has been successfully booked for {{ date }} at {{ time }}",
        "SUCCESS_WITHOUT_SPACE": "You meeting has been successfully booked for {{ date }} at {{ time }}",
        "SUCCESS_WITH_SPACE_ALLDAY": "Your room booking for {{ level }}, {{ space }} has been successfully booked for {{ date }}",
        "SUCCESS_WITHOUT_SPACE_ALLDAY": "Your meeting has been successfully booked for {{ date }}",
        "SUCCESS_WAIT_APPROVED": "Please allow up to 5 minutes for your booking to be approved.",
        "BOOK_NEARBY_DESK": "Book nearby desk",
        "SPACE_SELECT_SIZE": "Select room size",
        "SPACE_SELECT_SIZE_X": "Min. {{ count }} people",
        "SPACE_SELECT_SIZE_1": "Min. 1 person",
        "SPACE_ADD": "Add Space",
        "CAPACITY_COUNT": "Capacity {{ count }}",
        "SPACE_SELECT_FIND": "Find Space",
        "SPACE_SELECT_COUNT": "{{ count }} room(s) added",
        "FACILITIES": "Room Features",
        "SPACE_REMOVE": "Remove this room",
        "SPACE_ADD_TO": "Add this room",
        "SPACE_LIST_INFO": "Select a room to view its details",
        "SPACE_LOCATION": "Location",
        "SPACE_REGION_ANY": "Any region",
        "SPACE_LEVEL_ANY": "Any level",
        "SPACE_SELECT_EMPTY": "No available spaces for selected time and/or filters",
        "SPACE_SELECT_LOADING": "Finding available spaces...",
        "SPACE_BOOKING_RULES_HIDDEN_1": "The selected room is not available for the selected time or duration",
        "SPACE_BOOKING_RULES_HIDDEN_N": "Some of the selected rooms are not available for the selected time or duration",
        "CONFIRM_DETAILS": "Confirm Meeting",
        "FINISHED": "Return home",
        "LOADING": "Creating meeting requests...",
        "GROUP_NO_DESCRIPTION": "No description",
        "GROUP_UNCONFIRMED": "Room to be confirmed",
        "GROUP_NO_LOCATION": "No location set for this event",
        "GROUP_BOTH_LOCATIONS": "Can be attended online",
        "GROUP_REMOTE": "Remote event",
        "GROUP_ATTENDING": "{{ count }} attending",
        "GROUP_FEATURED": "Featured",
        "GROUP_INTERESTED": "Interested",
        "GROUP_NOT_INTERESTED": "Not Interested",
        "GROUP_INTEREST_ADD": "Indicate Interest",
        "GROUP_INTEREST_REMOVE": "Revoke Interest",
        "GROUP_ATTENDING_FIELD": "Attending",
        "GROUP_GOING": "Going",
        "GROUP_NOT_GOING": "Not Going",
        "GROUP_GOING_ADD": "Indicate Going",
        "GROUP_GOING_REMOVE": "Revoke Going",
        "GROUP_PROMOTE": "Promote Event",
        "GROUP_EDIT": "Edit Event",
        "GROUP_COPY_URL": "Copy URL",
        "GROUP_DELETE": "Delete Event",
        "GROUP_HOST": "Event by {{ name }}",
        "GROUP_WHEN_WHERE": "When and where",
        "GROUP_DATE_TIME": "Date and Time",
        "GROUP_ABOUT": "About this event",
        "GROUP_ATTENDEES": "{{ going }} going, {{ interested }} interested",
        "FIND_AVAILABILITY": "Find Availability",
        "RECURRING_TOOLTIP": "This event is part of a recurring series",
        "APPROVAL_REQUIRED_MSG": "Room selected for this booking requires approval and may not be confirmed until a later date.",
        "SETUP_BREAKDOWN_HEADER": "Set Event's Setup and Breakdown",
        "SETUP_DURATION": "Setup Duration",
        "BREAKDOWN_DURATION": "Breakdown Duration"
    },
    "CATERING": {
        "MENU": "Catering Menu",
        "ORDERS": "Catering Orders",
        "ORDER_LIST": "Orders",
        "CATERER": "Caterer",
        "CATERER_EMPTY": "No Caterer",
        "CATERERS": "Caterers",
        "CATERERS_ALL": "All Caterers",
        "QUANTITY": "Quantity",
        "TOTAL_COST": "Total Cost",
        "BOOKING_RULES": "Edit Config",
        "CHARGE_CODE": "Charge Code",
        "CHARGE_CODES": "Charge Codes",
        "CHARGE_CODES_EDIT": "Edit Charge Codes",
        "CHARGE_CODES_ADD": "Add Code",
        "CHARGE_CODES_REMOVE": "Remove Charge Code",
        "CHARGE_CODES_IMPORT": "Import Code",
        "CHARGE_CODE_DOWNLOAD": "Download Charge Codes CSV template",
        "CHARGE_CODE_SAVE": "Saving changes to charge codes...",
        "CHARGE_CODE_EMPTY": "No charge codes",
        "INVOICE_NUMBER": "Invoice No.",
        "ROOM_AVAILABILITY": "Room Availability",
        "MENU_ADD": "Add Item",
        "MENU_EDIT": "Edit Item",
        "MENU_EDIT_INFO": "To edit the menu de-select all levels from the top left",
        "MENU_NEW": "New Item",
        "MENU_REMOVE": "Remove Item",
        "MENU_IMPORT": "Import Catering Menu",
        "MENU_LOADING": "Loading menu items...",
        "MENU_IMPORT_LOADING": "Importing catering menu items...",
        "MENU_IMPORT_ERROR": "Failed to import catering menu. Error: {{ error }}",
        "MENU_IMPORT_SUCCESS": "Successfully imported catering menu. {{ count }} item(s) added.",
        "MENU_IMPORT_TEMPLATE": "Download Template",
        "MENU_IMPORT_FILE_SELECT": "Click to select file or Drag and drop files",
        "MENU_SEARCH": "Search menu items...",
        "OPTION_MENU": "Menus and Pricing",
        "OPTION_MENU_INFO": "View and Edit Menus and Pricing",
        "OPTION_ORDERS": "Today's Orders",
        "OPTION_ORDERS_INFO": "View Catering Orders and their statuses upon arrival",
        "STATUS_PENDING": "Pending",
        "STATUS_ACCEPTED": "Accepted",
        "STATUS_PREPARING": "Preparing",
        "STATUS_READY": "Ready",
        "STATUS_DELIVERED": "Delivered",
        "STATUS_CANCELLED": "Cancelled",
        "TAGS": "Dietary Tags",
        "TAG_GLUTEN_FREE": "Gluten Free (GF)",
        "TAG_VEGAN": "Vegan (VG)",
        "TAG_VEGETARIAN": "Vegetarian (V)",
        "TAG_DAIRY": "Contains Dairy (D)",
        "TAG_NUTS": "Contains Nuts (N)",
        "ORDER": "Catering Order",
        "ORDER_ITEM_COUNT": "{{ count }} item(s) added",
        "ORDER_SELECTED_HEADER": "Ordered Items",
        "ORDER_SELECTED_COUNT": "{{ count }} item(s)",
        "ORDER_ITEMS_EMPTY": "No available items for the selected time or filters",
        "ORDER_ITEMS_LOADING": "Finding available menu items...",
        "ORDER_ITEM_REMOVE": "Remove this item",
        "ORDER_ITEM_ADD": "Add this item",
        "ORDER_ITEM_SELECT": "Select an item to view its details",
        "ORDER_ALLOW": "Allow ordering this item from this zone",
        "ORDERS_EMPTY": "No catering orders for the selected date.",
        "ORDERS_DELIVER_TIME": "Deliver at {{ time }}",
        "ORDERS_LOCATION_EMPTY": "No Location",
        "ORDERS_CONFIRM": "Confirm Order",
        "ORDERS_SAVE": "Save Order",
        "ORDERS_SELECTED": "{{ count }} option(s) selected",
        "ORDERS_DELIVER_EXACT": "Exact Time",
        "ORDERS_DELIVER_EXACT_INFO": "Deliver at exactly specified time. \nNote that changes to the booking will not be \nreflected in the order if this is set.",
        "ORDERS_DELIVER_DATE": "Delivery Date",
        "ORDERS_DELIVER_AFTER": "Deliver After",
        "ITEM_OPTION_TYPE_REQUIRED": "A type is required",
        "ITEM_OPTION_TYPE_PLACEHOLDER": "Type of option. e.g. Number of sugars",
        "ITEM_OPTION_SELECT_MULTIPLE": "Can select multiple of the same type",
        "ITEM_LIST_EMPTY": "No catering items in the menu",
        "ITEM_PRICE": "Unit Price",
        "ITEM_DISCOUNT": "Discount Cap",
        "ITEM_ADD": "Add Item",
        "ITEM_NEW": "New Catering Item",
        "ITEM_EDIT": "Edit Catering Item",
        "ITEM_SAVING": "Saving catering item...",
        "ITEM_REMOVE": "Remove Catering Item",
        "ITEM_POINTS": "Accepts Points",
        "ITEM_REMOVE_MSG": "Are you sure you wish to remove the catering item \"{{ name }}\" from the menu?",
        "ITEM_REMOVE_LOADING": "Removing catering item...",
        "ITEM_REMOVE_SUCCESS": "Successfully removed catering item from menu.",
        "ITEM_REMOVE_ERROR": "Failed to remove catering item from menu. Error: {{ error }}",
        "ITEM_OPTION_AVAILABLE": "Options Available",
        "ITEM_OPTION_ADD": "Add Option",
        "ITEM_OPTION_NEW": "New Item Option",
        "ITEM_OPTION_EDIT": "Edit Item Option",
        "ITEM_OPTION_REMOVE": "Remove Item Option",
        "ITEM_OPTION_SHOW": "Show item's options",
        "ITEM_OPTION_HIDE": "Hide item's options",
        "ITEM_OPTION_SAVING": "Saving catering item option...",
        "ITEM_OPTION_REMOVE_MSG": "Are you sure you wish to remove the catering item option \"{{ name }}\" from {{ item }}?",
        "ITEM_OPTION_REMOVE_LOADING": "Removing catering item option...",
        "ITEM_OPTION_REMOVE_SUCCESS": "Successfully removed catering item option from {{ item }}.",
        "ITEM_OPTION_REMOVE_ERROR": "Failed to remove catering item option from {{ item }}. Error: {{ error }}"
    },
    "APP": {
        "WORKPLACE": {
            "MENU_HOME": "Home",
            "MENU_ROOMS": "Book Room",
            "MENU_DESKS": "Book Desk",
            "MENU_LOCKERS": "Book Locker",
            "MENU_PARKING": "Book Parking",
            "MENU_VISITORS": "Invite Visitor",
            "MENU_SCHEDULE": "Your Bookings",
            "MENU_CONTROL": "Room Control",
            "MENU_EXPLORE": "Spaces",
            "MENU_EVENTS": "Events",
            "MENU_DEALS": "Deals & Offers",
            "GLOBAL_SEARCH": "Search for people or spaces...",
            "GLOBAL_SEARCH_EMPTY": "No matches found.",
            "GLOBAL_SEARCH_START": "Start typing to search...",
            "WELCOME_MESSAGE": "Hello {{ name }},",
            "UPCOMING": "Your Bookings",
            "UPCOMING_VIEW": "View All",
            "UPCOMING_VIEW_BOOKINGS": "View All Bookings",
            "UPCOMING_EMPTY": "You have no upcoming bookings",
            "QUICK_LINKS_HEADER": "Make a reservation",
            "ONECLICK_LINKS_HEADER": "Quick Book",
            "QUICK_LINK_ROOMS": "Book a room",
            "QUICK_LINK_DESKS": "Book a desk",
            "QUICK_LINK_PARKING": "Book parking",
            "QUICK_LINK_LOCKERS": "Book a locker",
            "FAVOURITES_COUNT": "{{ count }} favourite(s)",
            "FAVOURITES_REMOVE": "Remove favourite",
            "FAVOURITES_EMPTY": "No favourites",
            "FAVOURITES_SHOW": "Show only favourites",
            "CAPACITY": "Capacity {{ count }}",
            "COLLEAGUES": "Colleagues",
            "COLLEAGUES_COUNT_1": "{{ count }} person",
            "COLLEAGUES_COUNT_N": "{{ count }} people",
            "COLLEAGUES_COUNT": "{{ count }} people",
            "COLLEAGUES_EMPTY": "No colleagues",
            "COLLEAGUE_NEW_MEETING": "Create Meeting",
            "COLLEAGUE_REMOVE": "Remove Colleague",
            "COLLEAGUE_ADD": "Add Colleague",
            "COLLEAGUE_SEARCH_EMPTY": "Start typing to search for users.",
            "COLLEAGUE_SEARCH_NO_MATCH": "No matching users found for \"{{ text }}\" ",
            "COLLEAGUE_SEARCH_LOADING": "Searching for users...",
            "COLLEAGUE_ADDED": "Successfully added \"{{ name }}\" to contacts",
            "COLLEAGUE_REMOVED": "Successfully removed \"{{ name }}\" from contacts",
            "AVAILABLE_LIST_HEADER": "Available Now",
            "AVAILABLE_LIST_SPACES": "Spaces",
            "AVAILABLE_LIST_SPACES_EMPTY": "No spaces available to book at the current time",
            "AVAILABLE_LIST_ROOMS": "Rooms",
            "AVAILABLE_LIST_ROOMS_EMPTY": "No rooms available to book at the current time",
            "SCHEDULE_EMPTY": "No bookings for the selected date(s)",
            "SCHEDULE_REMOVE_TITLE": "Delete booking",
            "SCHEDULE_REMOVE_MSG": "Delete the booking for {{ name }} at {{ time }}?",
            "SCHEDULE_REMOVE_SUCCESS": "Successfully deleted booking.",
            "SCHEDULE_REMOVE_ERROR": "Failed to delete booking. Error: {{ error }}",
            "SCHEDULE_REMOVE_LOADING": "Deleting booking...",
            "SCHEDULE_REMOVE_SERIES_TITLE": "Delete booking series",
            "SCHEDULE_REMOVE_SERIES_MSG": "Delete the recurring series of bookings for {{ name }} at {{ time }}?",
            "SCHEDULE_REMOVE_SERIES_SUCCESS": "Successfully deleted booking series.",
            "SCHEDULE_REMOVE_SERIES_ERROR": "Failed to delete booking series. Error: {{ error }}",
            "SCHEDULE_REMOVE_SERIES_LOADING": "Deleting booking series...",
            "SCHEDULE_END_TITLE": "End booking",
            "SCHEDULE_END_MSG": "End the booking for {{ name }} at {{ time }}?",
            "SCHEDULE_END_LOADING": "Ending booking...",
            "SCHEDULE_END_SUCCESS": "Successfully ended booking.",
            "SCHEDULE_END_ERROR": "Failed to end booking. Error: {{ error }}",
            "SCHEDULE_FILTERS": "Filters",
            "SCHEDULE_FILTERS_DISPLAY_HEADER": "Category Filters",
            "SCHEDULE_FILTER_ROOMS": "Rooms and meeting invites",
            "SCHEDULE_FILTER_DESKS": "Desk bookings",
            "SCHEDULE_FILTER_PARKING": "Car, bike, van and ACC bookings",
            "SCHEDULE_FILTER_VISITORS": "Visitor bookings",
            "SCHEDULE_FILTER_LOCKERS": "Locker bookings",
            "SCHEDULE_FILTER_EVENTS": "Registered public or organisation events",
            "MEETING_BOOK_NEW_HEADER": "New Meeting",
            "MEETING_BOOK_EDIT_HEADER": "Edit Meeting",
            "MEETING_IDLE_TITLE": "Idle Timeout",
            "MEETING_IDLE_MSG": "Your form data is out of date",
            "MEETING_FINISHED": "Return home",
            "MEETING_DESK_ERROR": "No available desks nearby",
            "MEETING_CONFIRM": "Confirm meeting booking",
            "MEETING_BOOKED_ROOM": "Booked Room",
            "MEETING_WITHOUT_ROOM_TITLE": "Make standalone booking",
            "MEETING_WITHOUT_ROOM_MSG": "You are creating a booking without a room. Would you like to proceed?",
            "LOCKER_ASSIGNED": "You are already assigned a locker \"{{ name }}\"",
            "LOCKER_CONFIRM_TITLE": "Confirm Locker Booking",
            "LOCKER_SUCCESS_MSG": "Your locker booking for \"{{ name }}\" at {{ place }} has been successfully booked for the {{ date }} at {{ time }}",
            "PARKING_NEW_HEADER": "New Parking Reservation",
            "PARKING_EDIT_HEADER": "Edit Parking Reservation",
            "PARKING_ASSIGNED": "You are already assigned a parking space \"{{ name }}\"",
            "PARKING_SUCCESS_HEADER": "Parking space reserved",
            "PARKING_SUCCESS_MSG": "Your parking space reservation for \"{{ name }}\" has been successfully booked for the {{ date }} at {{ time }}",
            "PARKING_CONFIRM_TITLE": "Confirm Parking Reservation",
            "DESK_ASSIGNED": "You are already assigned a desk \"{{ name }}\"",
            "DESK_CONFIRM_TITLE": "Confirm Desk Booking",
            "VIEW_SCHEDULE": "View your Bookings",
            "BOOKING_FINISHED": "Return home",
            "EVENTS_EMPTY": "No events for the selected time period",
            "EVENTS_RETRY": "Expand your search or try again",
            "CHAT_TITLE": "Virtual Assistant",
            "CHAT_HELLO": "Hi {{ name }}.",
            "CHAT_WELCOME": "Welcome to the virtual assistant",
            "CHAT_ASSISTANT": "Assistant",
            "CHAT_WAITING": "Waiting for a reply...",
            "CHAT_MESSAGE_PLACEHOLDER": "New message...",
            "DEAL_COUNT_1": "{{ count }} Offer",
            "DEAL_COUNT_N": "{{ count }} Offers",
            "SORT_BY_DATE_DESC": "Sort by Date (Newest First)",
            "SORT_BY_DATE_ASC": "Sort by Date (Oldest First)",
            "SORT_BY_RELEVANCE": "Sort by Relevance",
            "DEALS_EMPTY_HEADER": "No Deals or Offers Available",
            "DEALS_EMPTY_BODY": "We're working on bringing you exciting deals and offers. Please check back later or explore other sections.",
            "RESOURCE_CHECKED_IN_FAILED": "No booking found",
            "RESOURCE_CHECKED_IN": "Successfully checked in resource",
            "RESOURCE_CHECKED_IN_MESSAGE": "Resource checked in successfully"
        },
        "CONCIERGE": {
            "MENU_BOOKINGS": "Bookings",
            "MENU_ROOM_BOOKINGS": "Venues",
            "MENU_DESK_BOOKINGS": "Desks",
            "MENU_PARKING_BOOKINGS": "Parking",
            "MENU_LOCKER_BOOKINGS": "Lockers",
            "MENU_ASSET_BOOKINGS": "Assets",
            "MENU_CATERING_BOOKINGS": "Catering",
            "MENU_VISITORS": "Visitor Management",
            "MENU_VISITOR_BOOKINGS": "Visitors",
            "MENU_VISITOR_RULES": "External",
            "MENU_MANAGEMENT": "Facilities",
            "MENU_MANAGE_ZONES": "Zone Management",
            "MENU_MANAGE_REGIONS": "Region Management",
            "MENU_MANAGE_BUILDINGS": "Building Management",
            "MENU_MANAGE_LEVELS": "Level Management",
            "MENU_MANAGE_ROOMS": "Venue Management",
            "MENU_MANAGE_DESKS": "Desk Management",
            "MENU_MANAGE_PARKING": "Parking Management",
            "MENU_MANAGE_LOCKERS": "Locker Management",
            "MENU_MANAGE_CATERING": "Catering Menus",
            "MENU_MANAGE_POINTS": "Points",
            "MENU_MANAGE_CONTACTS": "Emergency Contacts",
            "MENU_MANAGE_SIGNAGE": "Digital Signage",
            "MENU_MANAGE_MAP_FEATURES": "Points of Interest",
            "MENU_MANAGE_URLS": "URL Management",
            "MENU_MANAGE_EMAILS": "Email Templates",
            "MENU_MANAGE_DEALS": "Deals & Offers",
            "MENU_ASSETS": "Asset Management",
            "MENU_USER_LIST": "User Directory",
            "MENU_EVENTS": "Events",
            "MENU_SURVEYS": "Surveys",
            "MENU_REPORTS": "Reports",
            "MENU_REPORT_ROOMS": "Room Bookings",
            "MENU_REPORT_DESKS": "Desk Bookings",
            "MENU_REPORT_PARKING": "Parking Reservations",
            "MENU_REPORT_LOCKERS": "Locker Bookings",
            "MENU_REPORT_CATERING": "Catering Orders",
            "MENU_REPORT_CONTACT_TRACING": "Contact Tracing",
            "MENU_REPORT_ASSETS": "Asset Requests",
            "MENU_REPORT_VISITORS": "Visitor Bookings",
            "TIMEZONE_DIFF": "Timezone of the building is displayed and is different from your local timezone.",
            "ROOM_BOOKINGS": "Venue Bookings",
            "VENUE_FILTER_ALL": "All Events",
            "VENUE_FILTER_INCOMING": "Incoming",
            "VENUE_FILTER_APPROVED": "Approved",
            "VENUE_FILTER_DECLINED": "Declined",
            "SETUP_BREAKDOWN": "Setup & Breakdown",
            "NEW_BOOKING": "New Booking",
            "BOOKING_REMOVE_TITLE": "Delete booking",
            "BOOKING_REMOVE_MSG": "Delete the booking for {{ name }} at {{ time }}?",
            "BOOKING_REMOVE_SUCCESS": "Successfully deleted booking.",
            "BOOKING_REMOVE_ERROR": "Failed to delete booking. Error: {{ error }}",
            "BOOKING_REMOVE_LOADING": "Deleting booking...",
            "ROOMS_PENDING_HEADER": "Pending Approval ({{ count }} of {{ total }})",
            "ROOMS_PENDING_EMPTY": "No pending requests",
            "ROOMS_PENDING_LOADING": "Processing...",
            "ROOMS_PENDING_SHOW": "Show Pending Approvals",
            "ROOMS_PENDING_HIDE": "Hide Pending Approvals",
            "ROOMS_SEARCH": "Search day's events...",
            "ROOMS_SEARCH_COUNT": "{{ count }} of {{ total }} event(s)",
            "ROOMS_EMPTY": "No events for the currently selected date and zone",
            "ROOMS_SEARCH_EMPTY": "No matching events found.",
            "ROOMS_BOOK_ADD": "New Meeting",
            "ROOMS_BOOK_NEW": "New Meeting Booking",
            "ROOMS_BOOK_EDIT": "Edit Meeting Booking",
            "DESKS_HEADER": "Desk Management",
            "DESKS_BOOK_HEADER": "Desk Bookings",
            "DESKS_BOOK_NEW": "New Desk Bookings",
            "DESKS_BOOK_EDIT": "Edit Desk Bookings",
            "DESKS_NEW": "New Desk",
            "DESKS_EDIT": "Edit Desk",
            "DESKS_ID": "Desk ID",
            "DESKS_NAME": "Desk Name",
            "DESKS_SAVING": "Saving desk details...",
            "DESKS_SAVE_ERROR": "Failed to save desk details. Error: {{ error }}",
            "DESKS_MAP_ID_PLACEHOLDER": "e.g. table-01.123",
            "DESKS_VIEW_QR_CODE_LIST": "View Desk QR Codes",
            "DESKS_LIST_UPLOAD": "Upload Desks CSV",
            "DESKS_LIST_DOWNLOAD": "Download Desk CSV template",
            "DESKS_BOOKING_RULES": "Desk Restrictions",
            "DESKS_BOOKINGS_EMPTY": "There are no desk booking for the currently selected date.",
            "DESKS_BOOKINGS_SEARCH_EMPTY": "No matching desk bookings",
            "DESKS_GROUP_EMPTY": "No Group",
            "DESKS_ACTION_APPROVE": "Approve Desk",
            "DESKS_ACTION_DECLINE": "Decline Desk",
            "DESKS_MANAGE_EMPTY": "No desks for the selected level",
            "DESKS_MANAGE_SEARCH_EMPTY": "No matching desks found",
            "DESKS_ACTION_PRINT_QR": "Print QR Code",
            "DESKS_ACTION_PRINT_QR_LIST": "Print QR Codes",
            "DESKS_ACTION_EDIT": "Edit Desk",
            "DESKS_ACTION_REMOVE": "Remove Desk",
            "DESKS_DROP_TEMPLATE": "Drop CSV file to add desks",
            "DESKS_ID_COPIED": "Desk ID copied to clipboard",
            "DESKS_REMOVE_TITLE": "Remove desk",
            "DESKS_REMOVE_MSG": "Remove desk {{ name }}?",
            "DESKS_REMOVE_LOADING": "Removing desk...",
            "DESKS_REMOVE_SUCCESS": "Successfully removed desk.",
            "DESKS_REMOVE_ERROR": "Failed to remove desk. Error: {{ error }}",
            "DESKS_UPLOADING": "Uploading desk details from CSV...",
            "DESKS_BOOKING_LOADING": "Performing booking request...",
            "DESKS_BOOKING_SUCCESS": "Successfully booked desk.",
            "DESKS_CHECKIN_ERROR": "Failed to check-in desk booking. Error: {{ error }}",
            "DESKS_CHECKIN_SUCCESS": "Successfully checked-in desk booking",
            "DESKS_CHECKOUT_ERROR": "Failed to check-out desk booking. Error: {{ error }}",
            "DESKS_CHECKOUT_SUCCESS": "Successfully checked-out desk booking",
            "DESKS_APPROVE_ERROR": "Failed to approve desk booking. Error: {{ error }}",
            "DESKS_APPROVE_SUCCESS": "Successfully approved desk booking",
            "DESKS_REJECT_ERROR": "Failed to reject desk booking. Error: {{ error }}",
            "DESKS_REJECT_SUCCESS": "Successfully rejected desk booking",
            "DESKS_ACCESS_ERROR": "Failed to give building access for desk booking. Error: {{ error }}",
            "DESKS_ACCESS_SUCCESS": "Successfully gave building access for desk booking",
            "DESKS_REJECT_ALL_TITLE": "Reject all desk bookings",
            "DESKS_REJECT_ALL_MSG": "Are you sure you want to cancel all bookings for the selected date?",
            "DESKS_REJECT_ALL_LOADING": "Rejecting all desks for selected date...",
            "DESKS_REJECT_ALL_SUCCESS": "Successfully rejected all desk bookings for selected date.",
            "DESKS_REJECT_ALL_ERROR": "Failed to reject all desk bookings for selected date. Error: {{ error }}",
            "DESKS_BOOKING_DELETE_TITLE": "Cancel Desk Booking",
            "DESKS_BOOKING_DELETE_CONTENT": "Are you sure you want to cancel the desk booking?",
            "DESKS_BOOKING_DELETE_LOADING": "Cancelling desk booking...",
            "DESKS_BOOKING_DELETE_ERROR": "Failed to cancel desk booking. Error: {{ error }}",
            "DESKS_BOOKING_DELETE_SUCCESS": "Successfully cancelled desk booking.",
            "DESKS_SECURITY": "Security Group",
            "BOOKING_DELETED": "Cancelled",
            "BOOKING_ENDED": "Manually Ended",
            "BOOKING_EXPIRED": "Expired",
            "BOOKING_STATUS_ENDED": "Ended",
            "BOOKING_STATUS_APPROVED": "Approved",
            "BOOKING_STATUS_DECLINED": "Declined",
            "BOOKING_STATUS_PENDING": "Pending",
            "ZONES_HEADER": "Zone Management",
            "TAB_REGIONS": "Regions",
            "TAB_BUILDINGS": "Buildings",
            "TAB_LEVELS": "Levels",
            "REGIONS_HEADER": "Region Management",
            "REGIONS_ADD": "Add Region",
            "REGIONS_NEW": "New Region",
            "REGIONS_EDIT": "Edit Region",
            "REGIONS_REMOVE": "Delete Region",
            "REGIONS_NAME": "Region Name",
            "REGIONS_BUILDINGS": "Buildings",
            "REGIONS_SAVING": "Saving region...",
            "REGIONS_EMPTY": "No Regions",
            "REGIONS_REMOVE_TITLE": "Remove Region",
            "REGIONS_REMOVE_MSG": "Are you sure you want to remove the region \"{{ name }}\"?",
            "REGIONS_REMOVE_LOADING": "Removing region...",
            "REGIONS_REMOVE_SUCCESS": "Successfully removed region",
            "REGIONS_REMOVE_ERROR": "Failed to remove region. Error: {{ error }}",
            "BUILDINGS_HEADER": "Building Management",
            "BUILDINGS_ADD": "Add Building",
            "BUILDINGS_NEW": "New Building",
            "BUILDINGS_EDIT": "Edit Building",
            "BUILDINGS_REMOVE": "Delete Building",
            "BUILDINGS_NAME": "Building Name",
            "BUILDINGS_COPIED_ID": "Building ID copied to clipboard.",
            "BUILDINGS_AUTO_RELEASE": "Auto-release Settings",
            "BUILDINGS_INDUCTION": "Induction Settings",
            "BUILDINGS_SUPPORT_TYPES": "Support Request Types",
            "BUILDINGS_LEVELS": "Levels",
            "BUILDINGS_SAVING": "Saving building...",
            "BUILDINGS_SAVE_SUCCESS": "Successfully saved building.",
            "BUILDINGS_SAVE_ERROR": "Failed to save building. Error: {{ error }}",
            "BUILDINGS_EMPTY": "No Buildings",
            "BUILDINGS_REMOVE_TITLE": "Remove Building",
            "BUILDINGS_REMOVE_MSG": "Are you sure you want to remove the building \"{{ name }}\"?",
            "BUILDINGS_REMOVE_LOADING": "Removing building...",
            "BUILDINGS_REMOVE_SUCCESS": "Successfully removed building",
            "BUILDINGS_REMOVE_ERROR": "Failed to remove building. Error: {{ error }}",
            "LEVELS_HEADER": "Level Management",
            "LEVELS_ADD": "Add Level",
            "LEVELS_NEW": "New Level",
            "LEVELS_EDIT": "Edit Level",
            "LEVELS_REMOVE": "Delete Level",
            "LEVELS_NAME": "Level Name",
            "LEVELS_COPIED_ID": "Level ID copied to clipboard.",
            "LEVELS_ROOMS": "Rooms",
            "LEVELS_MAP_URL": "Map URL",
            "LEVELS_BUILDING_REQUIRED": "A building zone is required",
            "LEVELS_HAS_PARKING": "Has parking spaces",
            "LEVELS_MAP_URL_PLACEHOLDER": "URL of the Map SVG file",
            "LEVELS_SAVING": "Saving level...",
            "LEVELS_SAVE_SUCCESS": "Successfully saved level.",
            "LEVELS_SAVE_ERROR": "Failed to save level. Error: {{ error }}",
            "LEVELS_EMPTY": "No Levels",
            "LEVELS_REMOVE_TITLE": "Remove Level",
            "LEVELS_REMOVE_MSG": "Are you sure you want to remove the level \"{{ name }}\"?",
            "LEVELS_REMOVE_LOADING": "Removing level...",
            "LEVELS_REMOVE_SUCCESS": "Successfully removed level",
            "LEVELS_REMOVE_ERROR": "Failed to remove level. Error: {{ error }}",
            "ROOMS_HEADER": "Venue Management",
            "ROOMS_ADD": "Add Venue",
            "ROOMS_NEW": "New Venue",
            "ROOMS_EDIT": "Edit Venue",
            "ROOMS_REMOVE": "Delete Venue",
            "ROOMS_NAME": "Venue Name",
            "ROOMS_TYPE": "Venue Type",
            "ROOMS_ALERT": "Alert",
            "ROOMS_CODE": "Code",
            "ROOMS_SETUP_INFO": "Time before a meeting needed for setup and preparation for the upcoming meeting",
            "ROOMS_BREAKDOWN_INFO": "Time after a meeting needed for cleaning and preparation for next meeting",
            "ROOMS_DEFAULT_SETUP": "Default Setup Duration",
            "ROOMS_DEFAULT_BREAKDOWN": "Default Breakdown Duration",
            "ROOMS_SELECT_LEVEL": "Select Level",
            "ROOMS_SET_ALERT": "Set Alert",
            "ROOMS_VIEW_CONTROL": "View Control Panel",
            "ROOMS_BOOKING_RULES": "Venue Restrictions",
            "ROOMS_COPIED_ID": "Venue ID copied to clipboard.",
            "ROOMS_LEVEL_REQUIRED": "A level zone is required",
            "ROOMS_HAS_PARKING": "Has parking spaces",
            "ROOMS_MAP_URL_PLACEHOLDER": "URL of the Map SVG file",
            "ROOMS_ALERT_HEADER": "Set alert for {{ name }}",
            "ROOMS_ALERT_TYPE_NONE": "None",
            "ROOMS_ALERT_TYPE_INFO": "Info",
            "ROOMS_ALERT_TYPE_WARNING": "Warning",
            "ROOMS_ALERT_TYPE_CLOSED": "Closed",
            "ROOMS_ALERT_MSG": "Message",
            "ROOMS_ALERT_LOAD_ERROR": "Failed to load existing venue alert details. Error: {{ error }}",
            "ROOMS_ALERT_SAVE_ERROR": "Failed to save venue alert details. Error: {{ error }}",
            "ROOMS_ALERT_SAVE_SUCCESS": "Successfully saved venue alert details",
            "ROOMS_SAVING": "Saving venue...",
            "ROOMS_SAVE_SUCCESS": "Successfully saved venue.",
            "ROOMS_SAVE_ERROR": "Failed to save venue. Error: {{ error }}",
            "ROOMS_LIST_EMPTY": "No venues",
            "ROOMS_REMOVE_TITLE": "Remove venue",
            "ROOMS_REMOVE_MSG": "Are you sure you want to remove the venue \"{{ name }}\"?",
            "ROOMS_REMOVE_LOADING": "Removing venue...",
            "ROOMS_REMOVE_SUCCESS": "Successfully removed venue",
            "ROOMS_REMOVE_ERROR": "Failed to remove venue. Error: {{ error }}",
            "ROOMS_APPROVE_SERIES": "Approve Series",
            "ROOMS_REJECT_SERIES": "Reject Series",
            "APP_SETTINGS": "Application Settings",
            "APP_SETTINGS_WORKPLACE": "Workplace Settings",
            "APP_SETTINGS_CONCIERGE": "Concierge Settings",
            "APP_SETTINGS_BOOKING_PANEL": "Booking Panel Settings",
            "APP_SETTINGS_VISITOR_KIOSK": "Visitor Kiosk Settings",
            "AUTO_RELEASE_HEADER": "Auto-release Settings",
            "AUTO_RELEASE_NOTIFY": "Notify before Booking",
            "AUTO_RELEASE_CANCEL": "Cancel Booking after",
            "AUTO_RELEASE_TYPES": "Booking types",
            "AUTO_RELEASE_LOADING": "Loading auto-release settings for building...",
            "AUTO_RELEASE_SAVING": "Saving auto-release settings...",
            "AUTO_RELEASE_ERROR": "Failed to save auto-release settings. Error: {{ error }}",
            "AUTO_RELEASE_SUCCESS": "Successfully saved auto-release settings.",
            "AUTO_RELEASE_DESK": "Custom desk auto-release",
            "AUTO_RELEASE_PARKING": "Custom parking auto-release",
            "AUTO_RELEASE_VISITOR": "Custom visitor auto-release",
            "AUTO_RELEASE_LOCKER": "Custom locker auto-release",
            "AUTO_RELEASE_ALL_DAY_START": "All Day Release time",
            "AUTO_RELEASE_OUTSIDE_HOURS": "Release outside business hours",
            "AUTO_RELEASE_DEFAULT_HOURS": "Default Work Hours",
            "AUTO_RELEASE_DEFAULT_HOURS_EMPTY": "No default works hours set",
            "AUTO_RELEASE_DEFAULT_HOURS_SET": "Set default works hours",
            "INDUCTION_HEADER": "Induction Settings",
            "INDUCTION_DETAILS": "Induction Details",
            "INDUCTION_ENABLE": "Enable induction for building",
            "INDUCTION_LOADING": "Loading induction settings for building...",
            "INDUCTION_SAVING": "Saving induction settings...",
            "INDUCTION_ERROR": "Failed to save induction settings. Error: {{ error }}",
            "INDUCTION_SUCCESS": "Successfully saved induction settings.",
            "VISITORS_DOWNLOAD": "Download Visitor List",
            "VISITORS_NOTES_EDIT": "Edit Visitor Notes",
            "VISITORS_NOTES_AVAILABLE": "Visitor Notes Available",
            "VISITORS_NOTES_HEADERS": "Notes for Visitor",
            "VISITORS_NOTES_SAVING": "Saving visitor notes...",
            "VISITORS_NOTES_ERROR": "Failed to save visitor notes. Error: {{ error }}",
            "VISITORS_NOTES_SUCCESS": "Successfully saved visitor notes.",
            "VISITORS_ACTION_APPROVE": "Approve Visitor",
            "VISITORS_ACTION_DECLINE": "Decline Visitor",
            "VISITORS_ACTION_ATTACHMENTS": "View Attachments",
            "VISITORS_ACTION_PARKING": "Reserve Parking Space",
            "VISITORS_ACTION_REMOTE": "Set visitor as Remote",
            "VISITORS_ACTION_ONSITE": "Set visitor as Onsite",
            "VISITORS_ACTION_PRINT_QR": "Print QR Code",
            "VISITORS_ACTION_PRINT_PASS": "Print Visitor Label",
            "VISITORS_ACTION_EMAIL_HOST": "Email Host",
            "VISITORS_ACTION_EMAIL_GUEST": "Email Guest",
            "VISITORS_ACTION_CHECKIN": "Check-in Guest",
            "VISITORS_ACTION_CHECKIN_ALL": "Check-in meeting Guests",
            "VISITORS_ACTION_CHECKOUT_ALL": "Check-out meeting Guests",
            "VISITORS_ACTION_CHECKOUT": "Check-out Guest",
            "VISITORS_ACTION_ID_APPROVE": "Approve ID",
            "VISITORS_ACTION_ID_REJECT": "Reject ID",
            "VISITORS_ACTION_EMAIL": "Email Access QR Code",
            "VISITORS_ACTION_SET_PASS": "Set Pass Number",
            "VISITORS_SAVED_PASS": "Successfully set pass number for visitor",
            "VISITOR_STATUS_CHECKED_IN": "Checked-in at: {{ time }}",
            "VISITOR_STATUS_CHECKED_OUT": "Checked-out at: {{ time }}",
            "VISITOR_STATUS_NOT_CHECKED_IN": "Not checked-in",
            "VISITOR_EMAIL_SUCCESS": "Successfully emailed access QR code to visitor",
            "SUPPORT_TYPES_HEADER": "Support Request Issue Types",
            "SUPPORT_TYPES_ADD": "Add Type",
            "SUPPORT_TYPES_NAME": "Issue Name",
            "SUPPORT_TYPES_EMAIL": "Issue Email",
            "SUPPORT_TYPES_REMOVE": "Remove Type",
            "CONTACTS_HEADER": "Emergency Contacts",
            "CONTACTS_FILTER": "Filter contacts...",
            "CONTACTS_ADD": "Add Contact",
            "CONTACTS_NEW": "New Emergency Contact",
            "CONTACTS_REMOVE": "Remove Emergency Contact",
            "CONTACTS_EDIT": "Edit Emergency Contact",
            "CONTACTS_ROLES": "Roles",
            "CONTACTS_ROLES_SAVE": "Save Role",
            "CONTACTS_ROLES_NAME": "Role Name",
            "CONTACTS_ROLES_ADD": "Add New Role",
            "CONTACTS_ROLES_SELECT": "Select contacts roles",
            "CONTACTS_PHONE_PLACEHOLDER": "Emergency contact number",
            "CONTACTS_ROLES_ALL": "All Roles",
            "CONTACTS_ROLES_MANAGE": "Manage Roles",
            "CONTACTS_EMPTY": "No emergency contacts for selected zone",
            "CONTACTS_SEARCH_EMPTY": "No matching contacts found",
            "CONTACTS_SAVING": "Saving contact details...",
            "CONTACTS_SAVE_SUCCESS": "Successfully saved contact details.",
            "CONTACTS_SAVE_ERROR": "Failed to save contact details. Error: {{ error }}",
            "DIRECTORY_ONSITE": "Onsite",
            "DIRECTORY_ONSITE_ONLY": "Onsite Only",
            "DIRECTORY_EMAIL": "Email Staff member",
            "DIRECTORY_PHONE": "Call Staff member",
            "DIRECTORY_SEARCH_EMPTY": "No matching staff members found.",
            "DIRECTORY_CHECKIN_ERROR": "Failed to check-in staff member. Error: {{ error }}",
            "DIRECTORY_CHECKOUT_ERROR": "Failed to check-out staff member. Error: {{ error }}",
            "POI_HEADER": "Points of Interest Management",
            "POI_ADD": "Add Point of Interest",
            "POI_NEW": "New Point of Interest",
            "POI_EDIT": "Edit Point of Interest",
            "POI_REMOVE": "Delete Point of Interest",
            "POI_PREVIEW": "Preview Point of Interest",
            "POI_SAVING": "Saving point of interest...",
            "POI_LIST_EMPTY": "No points of interest found.",
            "POI_SEARCHABLE": "Searchable",
            "POI_PRIVATE_QR": "Private QR Code",
            "POI_PUBLIC_QR": "Public QR Code",
            "POI_PRINT_QR": "Print QR Code",
            "POI_MAP_SELECT": "Select from map",
            "POI_MAP_SELECT_HEADER": "Select Point of Interest from map",
            "POI_MAP_SELECT_RESULTS": "Results ({{ count }})",
            "POI_MAP_SELECT_RESULTS_EMPTY": "No results found",
            "POI_MEDIA": "Media",
            "POI_MEDIA_URL": "Media URL",
            "POI_DETAILS": "Extra Details",
            "URLS_HEADER": "Short URL Management",
            "URLS_ADD": "Add Short URL",
            "URLS_NEW": "New Short URL",
            "URLS_EDIT": "Edit Short URL",
            "URLS_REMOVE": "Delete Short URL",
            "URLS_URI": "URI",
            "URLS_USER_NAME": "User Name",
            "URLS_ENABLED": "Enabled",
            "URLS_COPIED_ID": "URL copied to clipboard.",
            "URLS_SAVING": "Saving Short URL...",
            "URLS_SAVE_SUCCESS": "Successfully saved Short URL.",
            "URLS_SAVE_ERROR": "Failed to save Short URL. Error: {{ error }}",
            "URLS_EMPTY": "No Short URLs",
            "URLS_PRINT_QR": "Print QR Code",
            "URLS_REMOVE_TITLE": "Remove Short URL",
            "URLS_REMOVE_MSG": "Are you sure you want to remove the Short URL \"{{ name }}\"?",
            "URLS_REMOVE_LOADING": "Removing Short URL...",
            "URLS_REMOVE_SUCCESS": "Successfully removed Short URL",
            "URLS_REMOVE_ERROR": "Failed to remove Short URL. Error: {{ error }}",
            "EMAIL_TEMPLATES_HEADER": "Email Templates",
            "EMAIL_TEMPLATES_ADD": "Add Template",
            "EMAIL_TEMPLATES_NEW": "New Email Template",
            "EMAIL_TEMPLATES_EDIT": "Edit Email Template",
            "EMAIL_TEMPLATES_REMOVE": "Remove Template",
            "EMAIL_TEMPLATES_SAVE": "Save Template",
            "EMAIL_TEMPLATES_SEND_TEST": "Send test Email",
            "EMAIL_TEMPLATES_SENT_TEST": "Successfully sent test email.",
            "EMAIL_TEMPLATES_CONFIG_ERROR": "Mailing system is not configured for this application",
            "EMAIL_TEMPLATES_SAVE_SUCCESS": "Successfully saved email template.",
            "EMAIL_TEMPLATES_SAVE_ERROR": "Failed to save email template. Error: {{ error }}",
            "EMAIL_TEMPLATES_REMOVE_SUCCESS": "Successfully removed email template",
            "EMAIL_TEMPLATES_REMOVE_ERROR": "Failed to remove email template. Error: {{ error }}",
            "EMAIL_TEMPLATES_PLACEHOLDERS": "Placeholders",
            "EMAIL_TEMPLATES_PLACEHOLDERS_EMPTY": "No placeholders available",
            "EMAIL_TEMPLATES_REPLY_TO": "Reply to address",
            "EMAIL_TEMPLATES_REPLY_TO_REQUIRED": "A reply address is required",
            "EMAIL_TEMPLATES_FROM": "From address",
            "EMAIL_TEMPLATES_FROM_REQUIRED": "A from address is required",
            "EMAIL_TEMPLATES_SUBJECT_REQUIRED": "A subject line is required",
            "EMAIL_TEMPLATES_BODY": "Body of the email template",
            "EMAIL_TEMPLATES_LOADING": "Loading template details...",
            "EMAIL_TEMPLATES_SAVING": "Saving template details...",
            "EMAIL_TEMPLATES_COPIED_FIELD": "Copied placeholder field \"{{ field }}\" to clipboard.",
            "SURVEY_HEADER": "Surveys",
            "SURVEY_ADD": "Add Survey",
            "SURVEY_NEW": "New Survey",
            "SURVEY_EDIT": "Edit Survey",
            "SURVEY_TEST": "Test Survey",
            "SURVEY_REMOVE": "Delete Survey",
            "SURVEY_RESPONSES": "Survey Responses",
            "SURVEY_BUILDING_COUNT": "{{ count }} building(s)",
            "SURVEY_BUILDING_COUNT_N": "{{ count }} buildings",
            "SURVEY_BUILDING_COUNT_1": "{{ count }} building",
            "SURVEY_LIST_HEADER": "Survey Listing",
            "SURVEY_BLD_LIVE": "Live",
            "SURVEY_BLD_DRAFTS": "Drafts",
            "SURVEY_BLD_ANSWERS": "Answers",
            "SURVEY_ANSWERS_HEADER": "Survey Responses",
            "SURVEY_ANSWERS_QUESTIONS": "Total Questions",
            "SURVEY_ANSWERS_ANSWERS": "Total Answers",
            "SURVEY_ANSWERS_TRIGGER": "Triggered By",
            "SURVEY_ANSWERS_PAGE": "Page {{ id }}",
            "SURVEY_ANSWERS_PAGE_WITH_TITLE": "Page {{ id }} - {{ title }}",
            "SURVEY_ANSWERS_EMPTY": "No responses for this survey",
            "SURVEY_ANSWERS_ID_INVALID": "Invalid survey requested",
            "SURVEY_ANSWERS_LOADING": "Loading survey questions and responses...",
            "SURVEY_QUESTION_ADD": "Add Question",
            "SURVEY_QUESTION_NEW": "New Question",
            "SURVEY_QUESTION_EDIT": "Edit Question",
            "SURVEY_QUESTION_SEARCH": "Find question...",
            "SURVEY_QUESTION_TYPES_ALL": "All Types",
            "SURVEY_QUESTION_EMPTY": "No questions found.",
            "SURVEY_QUESTION_HEADER": "Question Bank",
            "SURVEY_QUESTION_REMOVE": "Remove Question",
            "SURVEY_QUESTION_ENTER": "Enter your question here",
            "SURVEY_QUESTION_ENTER_ERROR": "Please enter your question above",
            "SURVEY_QUESTION_HINT_MULTILINE": "*Type your answer above. Multiple lines supported",
            "SURVEY_QUESTION_HINT_RATING": "Move the slider to adjust the rating options",
            "SURVEY_QUESTION_HINT_LINE": "*Type your answer above.",
            "SURVEY_QUESTION_PAGE_NEW": "New Page",
            "SURVEY_QUESTION_PAGE_TITLE": "Page Title",
            "SURVEY_QUESTION_PAGE_REMOVE": "Remove Page",
            "SURVEY_QUESTION_EMPTY_ACTION": "Click + above to add some questions",
            "SURVEY_DND_INFO": "Drag and drop questions from the question bank here",
            "SURVEY_COMPLETE": "Thank you for completing the survey.",
            "SURVEY_BUILDER": "Builder",
            "PARKING_HEADER": "Parking Management",
            "PARKING_BOOK_HEADER": "Parking Reservations",
            "PARKING_ADD": "Add Reservation",
            "PARKING_NEW": "New Reservation",
            "PARKING_EDIT": "Edit Reservation",
            "PARKING_SPACE": "Parking Space",
            "PARKING_SPACE_ADD": "New Space",
            "PARKING_SPACE_NEW": "New Parking Space",
            "PARKING_SPACE_EDIT": "Edit Parking Space",
            "PARKING_SPACE_REMOVE": "Remove Parking Space",
            "PARKING_SPACE_SAVE": "Saving parking space details...",
            "PARKING_SPACE_NAME": "Parking Space Name / Bay Number",
            "PARKING_CAR_COLOUR": "Car Colour",
            "PARKING_SAVING": "Saving parking reservation...",
            "PARKING_SAVE": "Successfully saved parking reservation.",
            "PARKING_USER": "User",
            "USER_ASSIGNED": "Assigned User",
            "USER_CLEAR": "Clear Assigned User",
            "PARKING_USER_DENY": "Deny",
            "PARKING_USER_DENY_PLACEHOLER": "Deny User Parking Access",
            "PARKING_USER_ADD": "New User",
            "PARKING_USER_NEW": "New Parking User",
            "PARKING_USER_EDIT": "Edit Parking User",
            "PARKING_USER_REMOVE": "Remove Parking User",
            "PARKING_USER_REMOVE_MSG": "Are you sure you wish to remove the parking user \"{{ name }}\"?",
            "PARKING_USER_REMOVE_LOADING": "Removing parking user...",
            "PARKING_USER_REMOVE_ERROR": "Failed to remove parking user. Error: {{ error }}",
            "PARKING_USER_REMOVE_SUCCESS": "Successfully removed parking user.",
            "PARKING_USER_SAVE": "Saving parking user details...",
            "PARKING_BOOKING_RULES": "Parking Restrictions",
            "PARKING_TAB_SPACES": "Spaces",
            "PARKING_TAB_USERS": "Users",
            "PARKING_TAB_MAP": "Map",
            "PARKING_BAY": "Parking Bay",
            "PARKING_BAY_NUMBER": "Bay Number",
            "PARKING_RESERVED_FOR": "Reserved For",
            "PARKING_RESERVED_BY": "Reserved By",
            "PARKING_CHECKED_OUT_AT": "Left at {{ time }}",
            "PARKING_CHECKED_IN": "Arrived at space",
            "PARKING_NOT_CHECKED_IN": "Has not arrived at space",
            "PARKING_APPROVE": "Approve Reservation",
            "PARKING_APPROVE_ERROR": "Failed to approve the parking reservation. Error: {{ error }}",
            "PARKING_APPROVE_SUCCESS": "Successfully approved parking reservation.",
            "PARKING_DECLINE": "Reject Reservation",
            "PARKING_DECLINE_ERROR": "Failed to reject the parking reservation. Error: {{ error }}",
            "PARKING_DECLINE_SUCCESS": "Successfully rejected parking reservation.",
            "PARKING_CHECKIN_ERROR": "Failed to check-in parking reservation. Error: {{ error }}",
            "PARKING_CHECKIN_SUCCESS": "Successfully checked-in parking reservation.",
            "PARKING_CHECKOUT_ERROR": "Failed to check-out parking reservation. Error: {{ error }}",
            "PARKING_CHECKOUT_SUCCESS": "Successfully checked-out parking reservation.",
            "UNASSIGNED": "No assigned user",
            "PARKING_STATUS_ASSIGNED_FREE": "Space is assigned to a user but available for use",
            "PARKING_STATUS_ASSIGNED_BUSY": "Space is assigned to a user and in use",
            "PARKING_STATUS_ASSIGNED_OTHER": "Space is assigned to a user and in use by another user",
            "PARKING_STATUS_BUSY": "Space is not assigned and in use",
            "PARKING_STATUS_FREE": "Space is not assigned and available for use",
            "PARKING_COPIED_USER": "User's email copied to clipboard",
            "PARKING_COPIED_ID": "Parking Bay ID copied to clipboard",
            "PARKING_BOOKINGS_EMPTY": "No parking reservations for selected level and time",
            "PARKING_UNAVAILABLE": "No parking floors for the currently selected building",
            "EVENTS_HEADER": "Events",
            "EVENTS_ADD": "Add Event",
            "EVENTS_NEW": "New Group Event",
            "EVENTS_EDIT": "Edit Group Event",
            "EVENTS_VIEW": "View Group Event",
            "EVENTS_COPY_URL": "Copy URL",
            "EVENTS_REMOVE": "Remove Group Event",
            "EVENTS_REMOVE_TITLE": "Remove Group Event",
            "EVENTS_REMOVE_MSG": "Are you sure you wish to remove the group event \"{{ title }}\"?",
            "EVENTS_REMOVE_LOADING": "Removing group event...",
            "EVENTS_REMOVE_ERROR": "Failed to remove group event. Error: {{ error }}",
            "EVENTS_REMOVE_SUCCESS": "Successfully removed group event.",
            "EVENTS_PROMOTE": "Promote Event",
            "EVENTS_DRAFT": "Draft",
            "EVENTS_PUBLISH": "Publish (Internal)",
            "EVENTS_PUBLISH_PUBLIC": "Publish (Public)",
            "EVENTS_DATE_TIME": "Date and Time",
            "EVENTS_INFO": "Event Information",
            "EVENTS_SAVING": "Saving group event...",
            "EVENTS_LOADING": "Loading group events...",
            "EVENTS_LOCATION_ONLINE": "Online Only",
            "EVENTS_LOCATION_ONSITE": "On Premise",
            "EVENTS_LOCATION_BOTH": "Both",
            "EVENTS_MORE_COUNT": "{{ count }} more event(s)",
            "EVENTS_CONFIG_ERROR": "A shared calendar is required to view and manage group events.",
            "DEALS_HEADER": "Deals & Offers",
            "DEALS_ADD": "Add Deal",
            "DEALS_NEW": "New Deal",
            "DEALS_EDIT": "Edit Deal",
            "DEALS_REMOVE": "Remove Deal",
            "DEALS_VIEW": "View Deal",
            "DEALS_NOT_FOUND": "Unable to find deal with the ID '{{ id }}'",
            "DEALS_LOAD_EXISTING": "Loading deal/offer details...",
            "DEALS_SAVING": "Saving deal/offer...",
            "DEALS_REMOVE_TITLE": "Remove Deal/Offer",
            "DEALS_REMOVE_BODY": "Are you sure you want to remove this deal/offer?",
            "DEALS_SAVE_ERROR": "Failed to save deal/offer details. Error: {{ error }}",
            "DEALS_SAVED": "Successfully saved deal/offer details.",
            "DEALS_EMPTY_HEADER": "No Deals or Offers Available",
            "DEALS_EMPTY_BODY": "Add a new deal or offer to get started.",
            "LOCKERS_HEADER": "Locker Management",
            "LOCKERS_BOOK_HEADER": "Locker Bookings",
            "LOCKERS_BOOK_NEW": "New Locker Booking",
            "LOCKERS_BOOK_EDIT": "Edit Locker Booking",
            "LOCKERS_BOOK_REMOVE": "Remove Locker Booking",
            "LOCKERS_ADD": "Add Locker",
            "LOCKERS_NEW": "New Locker",
            "LOCKERS_EDIT": "Edit Locker",
            "LOCKERS_REMOVE": "Remove Locker",
            "LOCKERS_SHARE": "Share Locker",
            "LOCKERS_OPEN": "Open Locker",
            "LOCKERS_RELEASE": "Release Locker",
            "LOCKERS_SAVING": "Saving locker details...",
            "LOCKERS_BOOKING_RULES": "Locker Restrictions",
            "LOCKERS_REMOVE_TITLE": "Remove Locker",
            "LOCKERS_REMOVE_MSG": "Are you sure you wish to remove the locker \"{{ name }}\"?",
            "LOCKERS_REMOVE_LOADING": "Removing locker...",
            "LOCKERS_REMOVE_ERROR": "Failed to remove locker. Error: {{ error }}",
            "LOCKERS_REMOVE_SUCCESS": "Successfully removed locker.",
            "LOCKERS_LEVEL_SELECT": "Select a level to add a locker bank",
            "LOCKERS_EMPTY": "No lockers for this bank",
            "LOCKERS_ACCESSIBLE": "Accessible",
            "LOCKERS_ACCESSIBLE_INFO": "Locker is accessible",
            "LOCKERS_BANK": "Locker Bank",
            "LOCKERS_BANK_ADD": "Add Bank",
            "LOCKERS_BANK_NEW": "New Locker Bank",
            "LOCKERS_BANK_EDIT": "Edit Locker Bank",
            "LOCKERS_BANK_REMOVE": "Remove Locker Bank",
            "LOCKERS_BANK_SAVING": "Saving locker bank details...",
            "LOCKERS_BOOK_EMPTY": "No locker bookings for the currently selected date and zone.",
            "LOCKERS_BOOK_SEARCH_EMPTY": "No matching locker bookings found.",
            "LOCKERS_APPROVE": "Approve Locker",
            "LOCKERS_DECLINE": "Decline Locker",
            "LOCKERS_BANK_REMOVE_TITLE": "Remove Locker Bank",
            "LOCKERS_BANK_REMOVE_MSG": "Are you sure you wish to remove the locker bank \"{{ name }}\"?",
            "LOCKERS_BANK_REMOVE_LOADING": "Removing locker bank...",
            "LOCKERS_BANK_REMOVE_ERROR": "Failed to remove locker bank. Error: {{ error }}",
            "LOCKERS_BANK_REMOVE_SUCCESS": "Successfully removed locker bank.",
            "LOCKERS_BOOK_SAVING": "Saving locker booking...",
            "LOCKERS_BOOK_ERROR": "Failed to save locker booking. Error: {{ error }}",
            "LOCKERS_BOOK_SUCCESS": "Successfully saved locker booking.",
            "LOCKERS_BANK_EMPTY": "No locker banks for the selected zone",
            "LOCKERS_STATUS_ASSIGNED_FREE": "Locker is assigned to a user but available for use",
            "LOCKERS_STATUS_ASSIGNED_BUSY": "Locker is assigned to a user and in use",
            "LOCKERS_STATUS_ASSIGNED_OTHER": "Locker is assigned to a user and in use by another user",
            "LOCKERS_STATUS_BUSY": "Locker is not assigned and in use",
            "LOCKERS_STATUS_FREE": "Locker is not assigned and available for use",
            "LOCKERS_COPIED_USER": "User's email copied to clipboard",
            "LOCKERS_COPIED_ID": "Locker ID copied to clipboard",
            "LOCKERS_APPROVE_ERROR": "Failed to approve locker booking.",
            "LOCKERS_APPROVE_SUCCESS": "Successfully approved locker bookings for {{ name }}",
            "LOCKERS_REJECT_ERROR": "Failed to reject locker booking.",
            "LOCKERS_REJECT_SUCCESS": "Successfully rejected locker bookings for {{ name }}",
            "LOCKERS_REJECT_ALL_TITLE": "Cancel all locker bookings",
            "LOCKERS_REJECT_ALL_MSG": "Are you sure you want to cancel all bookings for the selected date?",
            "LOCKERS_REJECT_ALL_LOADING": "Rejecting all lockers for selected date...",
            "LOCKERS_REJECT_ALL_ERROR": "Failed to reject all locker booking for selected date.",
            "LOCKERS_REJECT_ALL_SUCCESS": "Successfully rejected all locker bookings for selected date.",
            "LOCKERS_OPEN_TITLE": "Open Locker",
            "LOCKERS_OPEN_MSG": "Are you sure you wish to open this locker? The contents of the locker will be accessible to anybody nearby.",
            "LOCKERS_OPEN_LOADING": "Opening locker...",
            "LOCKERS_OPEN_ERROR": "Failed to open locker. Error: {{ error }}",
            "LOCKERS_OPEN_SUCCESS": "Successfully opened locker",
            "LOCKERS_RELEASE_TITLE": "Release Locker",
            "LOCKERS_RELEASE_MSG": "Are you sure you wish to release this locker? This will cancel any bookings for the locker at this time.",
            "LOCKERS_RELEASE_LOADING": "Releasing locker...",
            "LOCKERS_RELEASE_ERROR": "Failed to release locker. Error: {{ error }}",
            "LOCKERS_RELEASE_SUCCESS": "Successfully released the locker",
            "LOCKERS_RELEASE_ALL": "Release All Lockers",
            "LOCKERS_RELEASE_ALL_TITLE": "Release All Lockers",
            "LOCKERS_RELEASE_ALL_MSG": "Are you sure you wish to release all the lockers? This will cancel all bookings for all the lockers at this time",
            "LOCKERS_RELEASE_ALL_LOADING": "Releasing all lockers...",
            "LOCKERS_RELEASE_ALL_ERROR": "Failed to release all lockers. Error: {{ error }}",
            "LOCKERS_RELEASE_ALL_SUCCESS": "Successfully released all locker",
            "LOCKERS_SHARE_ERROR": "Failed to share locker with \"{{ name }}\". Error: {{ error }}",
            "LOCKERS_SHARE_SUCCESS": "Successfully shared locker \"{{ name }}\" with {{ user }}",
            "LOCKERS_NO_DRIVER": "Driver is not set up for lockers",
            "LOCKERS_POSITION_INVALID": "Position of the locker overlaps with another locker",
            "LOCKERS_SIZE_INVALID": "Locker overlaps with another locker",
            "SIGNAGE_HEADER": "Digital Signage Management",
            "SIGNAGE_PLAYLIST": "Playlist",
            "SIGNAGE_PLAYLISTS": "Playlists",
            "SIGNAGE_PLAYLISTS_ADD": "Add Playlist",
            "SIGNAGE_PLAYLISTS_NEW": "New Playlist",
            "SIGNAGE_PLAYLISTS_EDIT": "Edit Playlist",
            "SIGNAGE_PLAYLISTS_VIEW": "View Playlist",
            "SIGNAGE_PLAYLISTS_REMOVE": "Remove Playlist",
            "SIGNAGE_PLAYLISTS_SAVE_SUCCESS": "Successfully saved playlist",
            "SIGNAGE_PLAYLISTS_MEDIA_SAVE_SUCCESS": "Successfully saved playlist media",
            "SIGNAGE_PLAYLISTS_EMPTY": "No playlists available",
            "SIGNAGE_PLAYLISTS_SEARCH_EMPTY": "No matching playlists found.",
            "SIGNAGE_PLAYLISTS_MEDIA_EMPTY": "No media in the selected playlist.",
            "SIGNAGE_PLAYLISTS_REMOVE_MSG": "Are you sure you wish to remove the playlist \"{{ name }}\"?",
            "SIGNAGE_PLAYLISTS_REMOVE_LOADING": "Removing playlist...",
            "SIGNAGE_PLAYLISTS_REMOVE_SUCCESS": "Successfully removed playlist",
            "SIGNAGE_PLAYLISTS_COPY_ID": "Copy Playlist's ID",
            "SIGNAGE_PLAYLISTS_APPROVE": "Review & Approve Playlist",
            "SIGNAGE_PLAYLISTS_NOT_APPROVED": "Playlist has unapproved changes",
            "SIGNAGE_PLAYLISTS_APPROVED": "Successfully approved playlist",
            "SIGNAGE_PLAYLISTS_UNDONE": "Successfully undone playlist changes",
            "SIGNAGE_DISPLAY": "Display",
            "SIGNAGE_DISPLAYS": "Displays",
            "SIGNAGE_DISPLAYS_ADD": "Add Display",
            "SIGNAGE_DISPLAYS_NEW": "New Display",
            "SIGNAGE_DISPLAYS_EDIT": "Edit Display",
            "SIGNAGE_DISPLAYS_REMOVE": "Remove Display",
            "SIGNAGE_DISPLAYS_EMPTY": "No displays",
            "SIGNAGE_DISPLAYS_SAVING": "Saving display...",
            "SIGNAGE_DISPLAYS_ZONE_ADD": "Add Zone",
            "SIGNAGE_DISPLAYS_SELECT": "Select a display from the left to view playlists",
            "SIGNAGE_DISPLAYS_OPEN_PLAYER": "Open Signage Player",
            "SIGNAGE_DISPLAYS_SET_ORIENTATION": "Set Orientation",
            "SIGNAGE_DISPLAYS_SEARCH_EMPTY": "No matching displays found",
            "SIGNAGE_DISPLAYS_PLAYLISTS_EMPTY": "No playlists in display \"{{ name }}\"",
            "SIGNAGE_DISPLAYS_REMOVE_MSG": "Are you sure you wish to remove the display \"{{ name }}\"?",
            "SIGNAGE_DISPLAYS_REMOVE_LOADING": "Removing display...",
            "SIGNAGE_DISPLAYS_REMOVE_SUCCESS": "Successfully removed display",
            "SIGNAGE_ORIENTATION_ERROR": "Failed to update display orientation. Error: {{ error }}",
            "SIGNAGE_ORIENTATION_CHANGED": "Successfully changed display orientation",
            "SIGNAGE_MEDIA": "Media",
            "SIGNAGE_MEDIA_REORDER": "Drag to reorder",
            "SIGNAGE_SEARCH_EMPTY": "No items available to select",
            "SIGNAGE_MEDIA_NEW": "New Media Item",
            "SIGNAGE_MEDIA_EDIT": "Edit Media Item",
            "SIGNAGE_MEDIA_PREVIEW": "Preview Media Item",
            "SIGNAGE_MEDIA_PREVIEW_HEADER": "Preview - {{ name }}",
            "SIGNAGE_MEDIA_REMOVE": "Remove Media Item",
            "SIGNAGE_MEDIA_ADD_PLAYLIST": "Add Media to Playlist",
            "SIGNAGE_MEDIA_DROP_UPLOAD": "Drop media to upload",
            "SIGNAGE_MEDIA_UPLOAD": "Upload Media",
            "SIGNAGE_MEDIA_LINK": "Add Media from URL",
            "SIGNAGE_MEDIA_ALL": "All Media",
            "SIGNAGE_MEDIA_COUNT": "{{ count }} playlist items",
            "SIGNAGE_MEDIA_COUNT_1": "{{ count }} playlist item",
            "SIGNAGE_MEDIA_SAVING": "Saving media item...",
            "SIGNAGE_MEDIA_SAVE": "Save Media",
            "SIGNAGE_MEDIA_FILE_ERROR": "Invalid file type",
            "SIGNAGE_MEDIA_SAVE_ERROR": "Failed to save media item. Error: {{ error }}",
            "SIGNAGE_MEDIA_SAVE_SUCCESS": "Successfully saved media item.",
            "SIGNAGE_MEDIA_EMPTY": "No media found.",
            "SIGNAGE_MEDIA_PLAY_TIME": "Play Time",
            "SIGNAGE_MEDIA_REMOVE_MSG": "Are you sure you wish to remove the media item \"<strong>{{ name }}</strong>\"?<br/><br/><i class=\"text-sm\">The item will be removed from all playlists and the files deleted from storage.</i>",
            "SIGNAGE_MEDIA_REMOVE_LOADING": "Removing media item...",
            "SIGNAGE_MEDIA_REMOVE_SUCCESS": "Successfully removed media item",
            "SIGNAGE_PLAYLISTS_SHUFFLE": "Shuffle Playlist",
            "SIGNAGE_SHUFFLE": "Shuffle ON",
            "SIGNAGE_ANIMATION": "Animation",
            "SIGNAGE_ANIMATION_DEFAULT": "Playlist Default",
            "SIGNAGE_ANIMATION_CUT": "Cut",
            "SIGNAGE_ANIMATION_CROSS_FADE": "Cross Fade",
            "SIGNAGE_ANIMATION_SLIDE_TOP": "Slide Top",
            "SIGNAGE_ANIMATION_SLIDE_LEFT": "Slide Left",
            "SIGNAGE_ANIMATION_SLIDE_RIGHT": "Slide Right",
            "SIGNAGE_ANIMATION_SLIDE_BOTTOM": "Slide Bottom",
            "SIGNAGE_DURATION": "Duration",
            "SIGNAGE_ORIENTATION": "Orientation",
            "SIGNAGE_ORIENTATION_NONE": "Unspecified",
            "SIGNAGE_ORIENTATION_LANDSCAPE": "Landscape",
            "SIGNAGE_ORIENTATION_PORTRAIT": "Portrait",
            "SIGNAGE_ORIENTATION_SQUARE": "Square",
            "SIGNAGE_ZONES": "Zones",
            "SIGNAGE_ZONES_SELECT": "Select a zone from the left to view playlists",
            "SIGNAGE_ZONES_EMPTY": "No zones",
            "SIGNAGE_ZONES_SEARCH_EMPTY": "No matching zones found.",
            "SIGNAGE_ZONES_PLAYLIST_ADDED": "Successfully added playlist to the zone.",
            "SIGNAGE_ZONES_PLAYLIST_REMOVED": "Successfully removed playlist to the zone.",
            "SIGNAGE_ZONES_PLAYLIST_REORDER": "Successfully re-ordered playlists for the zone.",
            "SIGNAGE_TRIGGERS_PLAYLIST_ADDED": "Successfully added playlist to the trigger.",
            "SIGNAGE_TRIGGERS_PLAYLIST_REMOVED": "Successfully removed playlist to the trigger.",
            "SIGNAGE_TRIGGERS_PLAYLIST_REORDER": "Successfully re-ordered playlists for the trigger.",
            "SIGNAGE_DISPLAYS_PLAYLIST_ADDED": "Successfully added playlist to the display.",
            "SIGNAGE_DISPLAYS_PLAYLIST_REMOVED": "Successfully removed playlist to the display.",
            "SIGNAGE_DISPLAYS_PLAYLIST_REORDER": "Successfully re-ordered playlists for the display.",
            "SIGNAGE_ZONE_ERROR": "Failed to add zone to display. Error: {{ error }}",
            "SIGNAGE_ZONE_ADDED": "Successfully added zone to display.",
            "ZONE_SELECT_HEADER": "Select a zone to add",
            "POINTS_HEADER": "Points Management",
            "POINTS_ASSETS_ADD": "Add Asset",
            "POINTS_ASSETS_NEW": "New Points Asset",
            "POINTS_ASSETS_EDIT": "Edit Points Asset",
            "POINTS_TAB_OVERVIEW": "Overview",
            "POINTS_TAB_ASSETS": "Assets",
            "POINTS_OVERVIEW_HEADER": "Points Overview",
            "POINTS_VALUE_INFO": "Set point redemption caps on menu items",
            "POINTS_VALUE_HEADER": "Point Value",
            "POINTS_ONE_POINT": "1 point",
            "POINTS_TYPE": "Asset Type",
            "POINTS_ACCEPT": "Accept Points?",
            "POINTS_ASSETS_SEARCH": "Search for assets...",
            "POINTS_ASSETS_SEARCH_EMPTY": "No matching assets found.",
            "POINTS_AUTO_REWARDS": "Automatic Rewards",
            "POINTS_REWARD_DESK": "Points for desk check-in",
            "POINTS_REWARD_ROOM": "Points for room check-in",
            "POINTS_REWARD_CANCEL": "Points for booking cancellation with more than 24 hour notice",
            "POINTS_REWARD_WELLNESS": "Points for completing wellness card",
            "POINTS_PRICE": "Unit Price",
            "POINTS_LABEL": "Points",
            "POINTS_DISCOUNT": "Discount %",
            "POINTS_DISCOUNT_CAP": "Discount Cap",
            "POINTS_STANDARD_RATE": "Standard hourly rate",
            "POINTS_RATE_RULES": "Rate Rules",
            "POINTS_RATE_RULES_NEW": "Add new rule",
            "POINTS_RATE_RULES_BEFORE": "Before",
            "POINTS_RATE_RULES_BETWEEN": "Between",
            "POINTS_RATE_RULES_AFTER": "After",
            "POINTS_ASSETS_EMPTY": "No priced assets",
            "ASSETS_HEADER": "Asset Requests",
            "ASSETS_REQUESTS": "Requests",
            "ASSETS_MANAGE_HEADER": "Asset Management",
            "ASSETS_MANAGE_CONFIG": "Edit Config",
            "ASSETS_MANAGE_BOOKING_RULES": "Room Availability",
            "ASSETS_MANAGE_CATEGORIES": "Manage Categories",
            "ASSETS_CATEGORY_NEW": "New Category",
            "ASSETS_CATEGORY_EDIT": "Edit Category",
            "ASSETS_CATEGORY_REMOVE": "Remove Category",
            "ASSETS_CATEGORY_PARENT": "Parent Category",
            "ASSETS_CATEGORY_PARENT_EMPTY": "No Parent",
            "ASSETS_CATEGORY_SAVING": "Saving category...",
            "ASSETS_CATEGORY_SAVE_ERROR": "Failed to save category. Error: {{ error }}",
            "ASSETS_ADD": "Add Asset",
            "ASSETS_NEW": "New Asset",
            "ASSETS_EDIT": "Edit Asset",
            "ASSETS_BULK_ADD": "Bulk Add Asset",
            "ASSETS_BULK_EDIT": "Bulk Edit Asset",
            "ASSETS_BULK_COUNT": "Number of assets to create",
            "ASSETS_PRODUCT": "Product",
            "ASSETS_PRODUCTS": "Products",
            "ASSETS_PO": "Purchase Orders",
            "ASSETS_SAVING": "Saving asset...",
            "ASSETS_SAVE_ERROR": "Failed to save asset. Error: {{ error }}",
            "ASSETS_SAVE_SUCCES": "Successfully saved asset.",
            "ASSETS_BULK_SAVING": "Saving assets...",
            "ASSETS_BULK_ASSET_LOADING": "Loading asset details...",
            "ASSETS_BULK_PRODUCT_LOADING": "Loading product details...",
            "ASSETS_BULK_COUNT_ERROR": "Please enter a valid number of assets to add.",
            "ASSETS_BULK_SAVE_ERROR": "Failed to save assets. Error: {{ error }}",
            "ASSETS_BULK_SAVE_SUCCESS": "Successfully saved {{ count }} assets.",
            "ASSETS_SERIAL_REQUIRED": "A serial number is required",
            "ASSETS_NAME_REQUIRED": "A display name is required",
            "ASSETS_ORDER_ID": "Purchase Order ID",
            "ASSETS_ORDER_SELECT": "Select Purchase Order",
            "ASSETS_ORDER_ID_EMPTY": "No purchase orders to select from",
            "ASSETS_ORDER_ID_REQUIRED": "A purchase order ID is required",
            "ASSETS_BARCODE": "Barcode",
            "ASSETS_BARCODE_REQUIRED": "A barcode is required",
            "ASSETS_ITEM_ADD": "Add Product",
            "ASSETS_ITEM_NEW": "New Product",
            "ASSETS_ITEM_EDIT": "Edit Product",
            "ASSETS_ITEM_SEARCH": "Search for products...",
            "ASSETS_ITEM_LOADING": "Loading product details...",
            "ASSETS_ITEM_DELETE_MSG": "Are you sure you want to permanently delete this product?",
            "ASSETS_ITEM_DELETE_ACTION": "Yes, delete",
            "ASSETS_ITEM_DELETE_LOADING": "Deleting product and associated assets...",
            "ASSETS_ITEM_AVAILABLE": "Available: {{ count }}",
            "ASSETS_ITEM_IN_USE": "In Use: {{ count }}",
            "ASSETS_ITEM_VIEW_LOCATIONS": "View Locations",
            "ASSETS_ITEM_TAB_ASSETS": "Assets",
            "ASSETS_ITEM_TAB_SPECS": "Specifications",
            "ASSETS_ITEM_TAB_PURCHASE_INFO": "Purchase Information",
            "ASSETS_ITEM_ASSET_ADD": "Add Asset",
            "ASSETS_ITEM_ASSET_BULK_ADD": "Bulk Add Asset",
            "ASSETS_ITEM_ASSET_EDIT": "Edit Asset",
            "ASSETS_ITEM_ASSET_REMOVE": "Remove Asset",
            "ASSETS_ITEM_ASSET_ID": "ID",
            "ASSETS_ITEM_ASSET_NAME": "Display Name",
            "ASSETS_ITEM_ASSET_SERIAL": "Serial Number",
            "ASSETS_ITEM_ASSET_EMPTY": "No assets for this product",
            "ASSETS_ITEM_PURCHASES_EMPTY": "No purchase orders for this product",
            "ASSETS_ITEM_GENERAL": "General",
            "ASSETS_ITEM_BRAND": "Brand",
            "ASSETS_ITEM_BRAND_REQUIRED": "A brand is required",
            "ASSETS_PURCHASE_ADD": "Add Purchase Order",
            "ASSETS_PURCHASE_NEW": "New Purchase Order",
            "ASSETS_PURCHASE_EDIT": "Edit Purchase Order",
            "ASSETS_PURCHASE_LOADING": "Loading purchase order details...",
            "ASSETS_PURCHASE_LOAD_ERROR": "Failed to load purchase order details",
            "ASSETS_PURCHASE_SAVING": "Saving purchase order details...",
            "ASSETS_PURCHASE_SAVE_ERROR": "Failed to save purchase order details. Error: {{ error }}",
            "ASSETS_PURCHASE_SAVE_SUCCESS": "Successfully saved purchase order details.",
            "ASSETS_PURCHASE_SEARCH": "Search for purchase orders...",
            "ASSETS_PURCHASE_NUMBER": "Order Number",
            "ASSETS_PURCHASE_NUMBER_REQUIRED": "An order number is required",
            "ASSETS_PURCHASE_INVOICE": "Invoice Number",
            "ASSETS_PURCHASE_INVOICE_REQUIRED": "An invoice number is required",
            "ASSETS_PURCHASE_DATE": "Purchase Date",
            "ASSETS_PURCHASE_START": "Service Start",
            "ASSETS_PURCHASE_END": "Service End",
            "ASSETS_PURCHASE_PRICE": "Purchase Price",
            "ASSETS_PURCHASE_ASSETS": "Associated assets ({{ count }})",
            "ASSETS_PURCHASE_ASSETS_EMPTY": "No assets for this purchase order",
            "ASSETS_PURCHASE_EMPTY": "There are purchase orders for this building.",
            "ASSETS_PURCHASE_SEARCH_EMPTY": "No matching purchase orders found.",
            "ASSETS_REQUESTS_SEARCH": "Search for asset requests...",
            "ASSETS_REQUESTS_COUNT": "{{ count }} asset request(s)",
            "ASSETS_REQUESTS_USER": "Requester",
            "ASSETS_REQUESTS_TIME": "Deliver At",
            "ASSETS_REQUESTS_ITEMS": "Assets Requested",
            "ASSETS_REQUESTS_DATE": "Date For",
            "ASSETS_REQUESTS_APPROVAL": "Approval",
            "ASSETS_REQUESTS_TRACKING": "Tracking",
            "ASSETS_REQUESTS_EMPTY": "There are no asset requests for the currently selected date.",
            "ASSETS_REQUESTS_SEARCH_EMPTY": "No matching asset requests",
            "ASSETS_REQUESTS_ACTION_APPROVE": "Approve Asset Request",
            "ASSETS_REQUESTS_ACTION_DECLINE": "Decline Asset Request",
            "ASSETS_REQUESTS_TRACKING_STORAGE": "In Storage",
            "ASSETS_REQUESTS_TRACKING_TRANSIT": "In Transit",
            "ASSETS_REQUESTS_TRACKING_LOCATION": "At Location",
            "REJECT_ALL": "Reject All",
            "BOOKED_FOR": "Booked For",
            "REPORTS_GENERATE": "Generate Report",
            "REPORTS_LOADING": "Loading report data...",
            "REPORTS_DOWNLOAD": "Download Report data",
            "REPORTS_DOWNLOAD_TABLE": "Download Table data",
            "REPORTS_PRINT": "Print Report",
            "REPORTS_EMPTY": "Select level(s) and date range to generate the report",
            "REPORTS_BUSINESS_DAYS": "Business Days",
            "REPORTS_TOTAL_BOOKINGS": "Total Bookings",
            "REPORTS_TOTAL_RESERVATIONS": "Total Reservations",
            "REPORTS_TOTAL_TIME": "Total Booked Time",
            "REPORTS_TOTAL_VISITORS": "Total Visitors",
            "REPORTS_AVERAGE_LENGTH": "Average Length",
            "REPORTS_NO_SHOWS": "No shows",
            "REPORTS_NO_SHOWS_COUNT": "No show count",
            "REPORTS_NO_SHOWS_PERCENT": "% of No shows",
            "REPORTS_TOTAL_ATTENDEES": "Total Room Attendees",
            "REPORTS_DAILY_HEADER": "Daily Utilisation",
            "REPORTS_DAILY_EMPTY": "No bookings for the select date range",
            "REPORTS_APPROVED": "Approved Bookings",
            "REPORTS_TOTAL_REQUESTS": "Total Requests",
            "REPORTS_TOTAL_BOOKED": "Total Booked",
            "REPORTS_UTILISATION": "Utilisation",
            "REPORTS_OCCUPANCY": "Occupancy %",
            "REPORTS_AVG_BOOKING_INVITES": "Avg. Invites per Booking",
            "REPORTS_AVG_DESKS": "Avg. Used Desks",
            "REPORTS_MIN_ATTENDANCE": "Min. In-Room Attendance",
            "REPORTS_MAX_ATTENDANCE": "Max. In-Room Attendance",
            "REPORTS_ROOMS_UTIL_HEADER": "Rooms Utilisation",
            "REPORTS_ROOMS_HOST_HEADER": "Meeting Organisers",
            "REPORTS_LEVEL_UTIL_HEADER": "Level Utilisation",
            "REPORTS_PARKING_UTIL_HEADER": "Parking Utilisation",
            "REPORTS_LOCKERS_UTIL_HEADER": "Lockers Utilisation",
            "REPORTS_HOST_COUNT_HEADER": "Reservee Count",
            "REPORTS_BOOKING_COUNT_HEADER": "Booking Count",
            "REPORTS_UNIQUE_HEADER": "Unique Resources Reserved",
            "REPORTS_ROOMS_HEADER": "Rooms Report",
            "REPORTS_DESKS_HEADER": "Desks Report",
            "REPORTS_PARKING_HEADER": "Parking Report",
            "REPORTS_LOCKERS_HEADER": "Lockers Report",
            "REPORTS_CATERING_HEADER": "Catering Report",
            "REPORTS_CONTACTS_HEADER": "Contact Tracing Report",
            "REPORTS_ASSETS_HEADER": "Assets Report",
            "REPORTS_VISITORS_HEADER": "Visitors Report",
            "REPORTS_LOAD_ERROR": "No bookings found for the selected zones and date range",
            "REPORTS_CATERING_ITEMS_HEADER": "Ordered Items",
            "REPORTS_CATERING_ITEMS_UNIQUE": "Unique Items",
            "REPORTS_CATERING_ITEMS": "Items",
            "REPORTS_CATERING_ORDERS_HEADER": "Orders",
            "REPORTS_CATERING_ORDERS_AVERAGE": "Order Average",
            "REPORTS_CATERING_ORDERS_EMPTY": "No orders for the selected date range",
            "REPORTS_CATERING_OPTIONS": "Options",
            "REPORTS_CATERING_OPTIONS_COUNT": "{{ count }} option(s)",
            "REPORTS_ASSETS_AVAILABLE": "Assets Available",
            "REPORTS_ASSETS_REQUESTEES": "Asset Request Users",
            "REPORTS_ASSETS_BOOKED": "Assets Booked",
            "REPORTS_ASSETS_TYPES": "Asset Types",
            "REPORTS_ASSETS_PRDOUCTS_HEADER": "Asset Requested Products",
            "REPORTS_ASSETS_EXPIRED_PO_HEADER": "Expired Assets Purchase Orders",
            "REPORTS_ASSETS_EXPIRED_PO_EMPTY": "No purchase orders expired for selected date range",
            "REPORTS_VISITORS_LIST_HEADER": "Visitors List",
            "REPORTS_VISITORS_SELF_REGISTERED": "Self Registered",
            "REPORTS_VISITORS_UNIQUE": "Unique Visitors",
            "REPORTS_VISITORS_HOSTS": "Host Count",
            "REPORTS_VISITORS_DAILY": "Daily Visitors",
            "APPROVER": "Approver",
            "VALID_FROM": "Valid From",
            "VALID_UNTIL": "Valid Until",
            "PLAY_FROM": "Play From",
            "PLAY_UNTIL": "Play Until",
            "PLAY_AT": "Play At",
            "PLAY_CRON": "Play Schedule",
            "PLAY_DURATION": "Play For",
            "PLAY_ONCE": "Play Once",
            "AVAILABLE_ROOMS_HEADER": "Set {{ type }} availability for rooms",
            "AVAILABLE_ROOMS_SAVING": "Saving room availability for {{ type }}...",
            "AVAILABLE_ROOMS_ENABLE": "Enable Selected",
            "AVAILABLE_ROOMS_DISABLE": "Disable Selected",
            "AVAILABLE_ROOMS_COUNT_1": "{{ count }} room",
            "AVAILABLE_ROOMS_COUNT_N": "{{ count }} rooms",
            "AVAILABLE_ROOMS_COUNT": "{{ count }} room(s)",
            "BOOKING_RULES_HEADER": "{{ type }} Booking Rules",
            "BOOKING_RULES_NEW": "New {{ type }} Booking Ruleset",
            "BOOKING_RULES_EDIT": "Edit {{ type }} Booking Ruleset",
            "BOOKING_RULES_NOTE": "Note that the order of the rulesets are important. The first ruleset that matches the resource will be used.",
            "BOOKING_RULES_AUTO_APPROVE": "Auto-approve",
            "BOOKING_RULES_HIDE_MATCHES": "Hide Matches",
            "BOOKING_RULES_CONDITIONS": "Conditions",
            "BOOKING_RULES_CONDITIONS_COUNT": "{{ count }} condition(s)",
            "BOOKING_RULESET_ADD": "Add Ruleset",
            "BOOKING_RULESET_EDIT": "Edit Ruleset",
            "BOOKING_RULESET_REMOVE": "Remove Ruleset",
            "BOOKING_RULESET_SAVE": "Save Ruleset",
            "BOOKING_RULESET_SAVING": "Saving booking rules...",
            "BOOKING_RULESET_ERROR": "Failed to save booking rules. Error: {{ error }}",
            "BOOKING_RULESET_SUCCESS": "Successfully saved booking rules.",
            "BOOKING_RULESET_PRIORITY_UP": "Increase Ruleset Priority",
            "BOOKING_RULESET_PRIORITY_DOWN": "Decrease Ruleset Priority"
        },
        "BOOKING_PANEL": {
            "ROOM_CAPACITY": "Room capacity",
            "CHECKIN_INPUT": "Touch or scan to check-in",
            "BOOKING_INPUT": "Touch or scan to book",
            "CHECKIN_INPUT_NOSCAN": "Touch to check-in",
            "BOOKING_INPUT_NOSCAN": "Touch to book",
            "END_INPUT": "Touch to end meeting",
            "SCAN_QR_CODE": "Scan QR code to book this room or view details",
            "NEXT": "Next",
            "NOW": "Now",
            "HOST": "Host:",
            "MEETING_IN_PROGRESS": "is currently in progress",
            "BOOK": "Book",
            "SCHEDULE": "Schedule",
            "FEATURES": "Features",
            "LIGHTS_BLINDS": "Lights & Blinds",
            "TV": "TV",
            "CATERING": "Catering",
            "HELP": "Help",
            "CHECKIN": "Check-in",
            "UPCOMING": "Upcoming",
            "NO_CURRENT": "No current events",
            "NO_UPCOMING": "No upcoming events",
            "BOOTSTRAP_TITLE": "PlaceOS Booking Panel",
            "LOADING_SYSTEM": "Loading system data...",
            "FREE_IN_HOURS_AND_MINUTES": "Free in {{ hour }} hours and {{ minute }} minutes",
            "FREE_IN_MINUTES": "Free in {{ minute }} minutes",
            "FREE_IN_LESS_THAN_MINUTE": "Free in less than a minute",
            "FREE_FOR_HOURS_AND_MINUTES": "Free for {{ hour }} hours and {{ minute }} minutes",
            "FREE_FOR_MINUTES": "Free for {{ minute }} minutes",
            "FREE_FOR_LESS_THAN_MINUTE": "Free for less than a minute",
            "EARLY_CHECKIN": "Meeting has been checked in early",
            "BOOKING_NEW": "New Booking",
            "BOOKING_HOST": "Booked by",
            "BOOKING_LOADING": "Processing booking request..."
        },
        "CONTROL": {
            "BOOTSTRAP_TITLE": "Control Panel Setup",
            "TOUCH_TO_START": "Touch to Start",
            "CONNECTING": "Connecting to system ({{ id }})...",
            "REMAINING": "Remaining",
            "NEXT_RECORDING": "Next Recording",
            "STATE_RECORDING": "Recording",
            "STATE_PAUSED": "Paused",
            "STATE_IDLE": "Idle",
            "ACTION_PHONE": "Phone",
            "ACTION_CONFERENCE": "Video Conference",
            "ACTION_JOIN_MEETING": "Join Meeting",
            "ACTION_LIGHT_SCENES": "Lighting Scenes",
            "ACTION_LIGHTING": "Lighting",
            "ACTION_LIGHTING_LEVELS": "Lighting Levels",
            "ACTION_ACCESSORIES": "Accessories",
            "ACTION_MICS": "Microphones",
            "ACTION_CAMERAS": "Cameras",
            "ACTION_HELP": "Help",
            "ACTION_JOIN_ROOMS": "Join Rooms",
            "ACTION_POWER": "Power",
            "OUTPUTS_EMPTY": "No output devices set up for this system.",
            "CONTROLS_EMPTY": "No controls available for this input source",
            "INPUT_EMPTY": "No input source",
            "INPUT_CATEGORY_EMPTY": "No inputs available for category",
            "INPUTS_AVAILABLE": "Available Inputs",
            "ROOMS_JOINED": "This room has been combined and is controlled from another panel",
            "VC_ENTER_CODE": "Enter your video conference code",
            "VC_DIAL": "Dial number...",
            "VC_JOINING": "Joining video conference...",
            "VC_CONTENT_DEST": "HDMI Content Destination",
            "VC_CONTENT_DEST_HIDE": "Hide Presentation",
            "VC_CONTENT_DEST_LOCAL": "Present Locally",
            "VC_CONTENT_DEST_ALL": "Present to All",
            "VC_LAYOUT": "Video Layout",
            "VC_LAYOUT_SELECT": "Select video layout",
            "VC_END_CALL": "End Call",
            "VC_MICS_MUTE": "Mute Microphones",
            "VC_MICS_UNMUTE": "Unmute Microphones",
            "VC_ON_HOLD": "Place on Hold",
            "VC_RESUME": "Resume Call",
            "VC_PIP_SHOW": "Show Camera PIP",
            "VC_PIP_HIDE": "Hide Camera PIP",
            "VC_JOIN_ERROR": "Unable to find active video conference",
            "VC_LEAVE_ERROR": "Failed to hung up call. Error: {{ error }}",
            "VC_LEAVE_LOADING": "Hanging up call...",
            "VC_LOADING": "Loading call details...",
            "VC_IN_CALL": "In Call",
            "VC_VIEW_CALL": "View Call",
            "VC_VIEW_INPUTS": "View Inputs",
            "CONTROLS": "Controls",
            "ZOOM": "Zoom",
            "CAMERA_SELECT": "Select Camera",
            "CAMERA_PRESETS": "Presets",
            "CAMERA_PRESETS_NEW": "New preset name",
            "CAMERA_PRESETS_SAVE": "Save Preset",
            "CAMERA_PRESETS_EMPTY": "No presets for this camera",
            "CAMERA_SELECT_MSG": "Select a camera to control.",
            "CAMERAS_EMPTY": "No cameras available for this system",
            "BACKSPACE": "Backspace",
            "HELP_CONTACT": "Need Help?",
            "HELP_CONTACT_MSG": "Contact {{ contact }} if you require <br/> assistance at <a href=\"mailto:{{ email }}\">{{ email }}</a> or phone <a href=\"tel:{{ phone }}\">{{ phone }}</a>",
            "JOIN": "Join",
            "LIGHT_SCENES_EMPTY": "No scenes available for lighting",
            "LIGHTING": "Lighting Presets",
            "LIGHTING_LEVELS": "Lighting Levels",
            "LIGHTING_EMPTY": "No presets available for lights",
            "MICS_EMPTY": "No microphones available for system",
            "OUTPUT_SWITCH": "Click to switch input source",
            "PHONE": "Phone Number",
            "PHONE_DIAL": "Dial Phone",
            "PHONE_HANGUP": "Hangup",
            "POWER_MSG": "Are you sure you want to shutdown<br/>the system?",
            "POWER_CONFIRM": "Yes, I'm sure",
            "POWER_CANCEL": "No, go back",
            "ACCESSORIES": "Room Accessories",
            "ACCESSORIES_EMPTY": "No room accessories available on system",
            "MEETING_SELECT": "Select a meeting to join",
            "MEETING_JOIN_INFO": "If you are joining the meeting on behalf of another, please use the dropdown to select their email",
            "MEETING_COUNT": "{{ count }} available meeting(s)",
            "MEETINGS_EMPTY": "No meetings found for selected calendar with a meeting URL",
            "MEETINGS_LOADING": "Loading meetings...",
            "MEETING_JOIN_TITLE": "Join Meeting",
            "MEETING_JOIN_MSG": "Are you sure you wish to join {{ name }}'s meeting starting at {{ time }}?",
            "MEETING_JOIN_LOADING": "Joining meeting...",
            "MEETING_JOIN_SUCCESS": "Successfully joined meeting.",
            "SOURCE_INPUT_SELECT": "Select input source for {{ name }}",
            "SOURCE_INPUTS_EMPTY": "No input sources available for the selected output({{ name }})",
            "SOURCE_SWITCHING": "Switching input source..."
        },
        "SIGNAGE": {
            "BOOTSTRAP_TITLE": "Control Panel Setup",
            "BOOTSTRAP_BUILDING": "Select a building from the dropdown below",
            "BOOTSTRAP_BUILDING_SELECT": "Select Building",
            "BOOTSTRAP_DISPLAY": "Select a display from the dropdown below",
            "BOOTSTRAP_DISPLAY_SELECT": "Select Display",
            "BOOTSTRAP_LOADING": "Initialising application...",
            "BOOTSTRAP_LOADING_CHECK": "Checking for existing application setup...",
            "PREVIOUS": "Previous Media",
            "PLAY": "Playing",
            "PAUSE": "Paused",
            "NEXT": "Next Media",
            "VOLUME": "Volume [{{ state }}]",
            "LOOP_ALL": "Loop [All]",
            "LOOP_ONE": "Loop [One]",
            "LOOP_OFF": "Loop [Off]",
            "SHUFFLE": "Shuffle [{{ state }}]",
            "MEDIA_LIST": "Media to play",
            "MEDIA_LIST_END": "End of player media",
            "MEDIA_LIST_EMPTY": "No media available to play",
            "PLAYLIST_LENGTH": "{{ count }} items",
            "PLAYLIST_LENGTH_1": "{{ count }} item",
            "PLAYLIST_LENGTH_N": "{{ count }} items"
        },
        "OUTLOOK": {},
        "MAP_KIOSK": {},
        "CATERER_PANEL": {},
        "ENROLMENT": {},
        "TIMETABLE": {},
        "VISITOR_KIOSK": {
            "APP": "Visitor Kiosk",
            "SELECT_REGION_MSG": "Select a region from the dropdown below",
            "SELECT_REGION": "Select region",
            "SELECT_BUILDING_MSG": "Select a building from the dropdown below",
            "SELECT_BUILDING": "Select building",
            "SELECT_LEVEL_MSG": "Select a level from the dropdown below",
            "SELECT_LEVEL": "Select level",
            "SELECT_ORIENTATION_MSG": "Select an orientation from the dropdown below",
            "SELECT_ORIENTATION": "Select orientation",
            "SELECT_LOCATION_MSG": "Select a fixed location from the dropdown below",
            "SELECT_LOCATION": "Select location",
            "WELCOME_MESSAGE": "<p>Welcome to Place<span class=\"text-primary\">OS</span></p><p>Self Service Kiosk</p>",
            "CHECK_IN": "Check-in or out",
            "VISITOR": "Visitor",
            "REGISTER": "Register",
            "REGISTRATION": "Visitor Registration",
            "REGISTERING": "Registering visitor...",
            "REGISTRATION_ERROR": "Failed to register visitor. Error: {{ error }}",
            "EXPLORE": "Explore",
            "QR_CODE_MSG": "Please enter your email address or scan your QR code",
            "NAME": "Name",
            "EMAIL": "Email",
            "INVALID_EMAIL": "Invalid email address",
            "EMAIL_REQUIRED": "A valid email address is required",
            "FIND_DETAILS": "Find Details",
            "LOADING_DETAILS": "Loading visitor information...",
            "CAMERA_UNAVAILABLE": "Camera feed loading...",
            "HOST": "Host",
            "PHONE": "Phone",
            "ORGANISATION": "Organisation",
            "REASON": "Reason for visit",
            "CHECKED_IN_MSG": "You are checked in!",
            "CHECKED_IN_MSG_SELF_REG": "Your registration is confirmed!",
            "TAKE_PHOTO": "Take a photo to continue",
            "TAKE_PHOTO_ACTION": "Take Photo",
            "PLEASE_WAIT": "Please wait...",
            "CONFIRM": "Done",
            "SKIP": "Skip",
            "PRINT_LABEL": "Print Label",
            "PRINT_LOADING": "Printing visitor label...",
            "LABEL_FOR": "For: {{ title }}",
            "LABEL_HOST": "Seeing {{ host_name }}",
            "LABEL_LOCATION": "Cleared for {{ location }}",
            "ARRIVED_MSG": "Your visitor \"{{ name }}\" has arrived and is waiting at reception",
            "INDUCTION_MSG": "Please read the induction information below before proceeding",
            "ACCEPT_TERMS": "I agree",
            "ACCEPT": "Accept",
            "DECLINE": "Decline",
            "CHECKIN_LOADING": "Saving details and checking in...",
            "CONTINUE": "Next",
            "SAVE": "Save",
            "BEVERAGES": "Beverages",
            "BEVERAGE_MSG": "Would you like a drink?",
            "BEVERAGE_SELECT": "Select a drink",
            "BEVERAGE_MENU_LOADING": "Loading beverage list...",
            "BEVERAGE_LOADING": "Requesting drink...",
            "BEVERAGE_SUCCESS": "Successfully requested drink. Your request should show up at your meeting shortly after the start time.",
            "ERROR_PRINT": "Failed to print visitor label.",
            "ERROR_CHECKIN": "Failed to check in {{ guest }} for {{ host }}'s meeting.",
            "SUCCESS_CHECKIN": "Successfully checked in {{ guest }} for {{ host }}'s meeting",
            "NOT_FOUND": "No meetings for guest \"{{ email }}\" today",
            "LOAD_ERROR": "Failed to load booking for guest.",
            "UPDATE_SUCCESS": "Successfully updated booking for guest.",
            "CHECKOUT": "Check-out from building",
            "CHECKOUT_MSG": "You are currently checked in to the building. Would you like to check out?",
            "CHECKOUT_LOADING": "Checking out guest...",
            "CHECKOUT_SUCCESS": "Successfully checked out guest."
        },
        "STAGEHAND": {
            "DASHBOARD_HEADER": "Alert Dashboards",
            "DASHBOARD_ADD": "Add Dashboard",
            "DASHBOARD_EDIT": "Edit Dashboard",
            "DASHBOARD_NEW": "New Dashboard",
            "DASHBOARD_VIEW": "View Dashboard",
            "DASHBOARD_BACK": "Back to Dashboards",
            "DASHBOARD_REMOVE": "Remove Dashboard",
            "DASHBOARD_REMOVE_HEADER": "Remove Dashboard",
            "DASHBOARD_REMOVE_CONTENT": "Are you sure you want to remove the dashboard \"{{ name }}\"?",
            "DASHBOARD_REMOVE_SUCCESS": "Successfully removed dashboard",
            "DASHBOARD_MANAGE_ALERTS": "Manage Alerts",
            "DASHBOARD_ALERTS_HEADER": "Dashboard Alerts",
            "DASHBOARD_ALERTS_ADD": "Add Alert",
            "DASHBOARD_ALERTS_EDIT": "Edit Alert",
            "DASHBOARD_ALERTS_NEW": "New Alert",
            "DASHBOARD_ALERTS_REMOVE": "Remove Alert",
            "DASHBOARD_ALERTS_OPEN": "View Alerts",
            "DASHBOARD_ALERTS_CLOSE": "Hide Alerts",
            "DASHBOARD_ALERTS_REMOVE_HEADER": "Remove Dashboard Alert",
            "DASHBOARD_ALERTS_REMOVE_CONTENT": "Are you sure you want to remove the dashboard alert \"{{ name }}\"?",
            "DASHBOARD_ALERTS_REMOVE_SUCCESS": "Successfully removed dashboard alert",
            "ALERT_FIELD_SEVERITY": "Severity",
            "ALERT_SEVERITY_LOW": "Low",
            "ALERT_SEVERITY_MEDIUM": "Informational",
            "ALERT_SEVERITY_HIGH": "Warning",
            "ALERT_SEVERITY_CRITICAL": "Critical",
            "ALERT_FIELD_TYPE": "Alert Type",
            "ALERT_TYPE_THRESHOLD": "Threshold",
            "ALERT_TYPE_STATUS": "Status",
            "ALERT_TYPE_CUSTOM": "Custom",
            "ALERT_CONDITIONS": "Conditions",
            "ALERT_SYSTEM_SEARCH": "Search for system...",
            "ALERT_MATCH_ANY": "Match any condition"
        }
    },
    "TRIGGERS": {
        "FIELD_ADDED": "Added",
        "FIELD_STATE": "State",
        "REFERENCE_SYSTEM": "Reference System",
        "REFERENCE_SYSTEM_MSG": "System to use for available status variables and function calls",
        "CONDITIONS": "Conditions",
        "CONDITION_ADD": "Add Condition",
        "CONDITION_NEW": "New Condition",
        "CONDITION_EDIT": "Edit Condition",
        "CONDITION_FIELD_TYPE": "Condition Type",
        "CONDITION_COMPARE": "Compare Values",
        "CONDITION_TIME": "Particular Time",
        "CONDITION_COMPARE_EMPTY": "No variable comparision conditions for this alert",
        "CONDITION_TIME_EMPTY": "No time dependant conditions for this alert",
        "CONDITION_SAVE_ERROR": "Failed to save alert condition. Error {{ error }}",
        "CONDITION_SAVE_SUCCESS": "Successfully saved alert condtion",
        "FIELD_VAR_COMPARE": "Variable Comparison Condition",
        "FIELD_TIME_DEPS": "Time dependant Condition",
        "REMOVE_CONDITION_TITLE": "Remove alert condition",
        "REMOVE_CONDITION_MSG": "Are you sure you want remove this alert condition?<br>All systems using this alert will be updated <strong>immediately</strong>.",
        "REMOVE_CONDITION_LOADING": "Removing alert condition...",
        "REMOVE_CONDITION_ERROR": "Failed to remove alert condition. Error: {{ error }}",
        "REMOVE_CONDITION_SUCCESS": "Successfully removed alert condition.",
        "TIME_SCHEDULE": "Recurring Schedule",
        "TIME_REPEAT": "Repeat Every",
        "TIME_DAY_OF_MONTH": "Day of Month",
        "TIME_MONTH_OF_YEAR": "Month of Year",
        "TIME_DAY_OF_WEEK": "Day of Week",
        "TIME_HOUR_OF_DAY": "Hour of the day",
        "TIME_MINUTE_OF_HOUR": "Minute of the hour",
        "TIME_FIELD_DATE": "Date",
        "TIME_FIELD_TIME": "Time",
        "COMPARE_CONSTANT": "Constant Value",
        "COMPARE_VARIABLE": "Status Variable",
        "COMPARE_VARIABLE_SELECT": "Select status variable",
        "COMPARE_VARIABLE_ERROR": "A module status variable is required",
        "COMPARE_OP": "Operation",
        "COMPARE_OP_EQUAL": "equal to",
        "COMPARE_OP_NOT_EQUAL": "not equal to",
        "COMPARE_OP_GREATER": "greater than",
        "COMPARE_OP_GREATER_EQUAL": "greater than or equal",
        "COMPARE_OP_LESS": "less than",
        "COMPARE_OP_LESS_EQUAL": "less than or equal",
        "COMPARE_OP_AND": "truthy AND",
        "COMPARE_OP_OR": "truthy OR",
        "COMPARE_OP_XOR": "truthy XOR",
        "COMPARE_OP_SELECT": "Select comparision operator",
        "COMPARE_TO": "Compared to",
        "COMPARE_JSON_REQUIRED": "Valid JSON is required",
        "COMPARE_MODULE_SELECT": "Select module",
        "COMPARE_SUBKEYS": "Subkeys",
        "COMPARE_SUBKEYS_PLACEHOLDER": "Status variable subkeys",
        "COMPARE_VARIABLE_LOAD_ERROR": "Failed to load status variables from {{ system }}, {{ module }}",
        "ENABLE_WEBHOOK": "Enable Webhook",
        "DEBOUNCE_PERIOD": "Debounce Period",
        "SUPPORTED_METHODS": "Supported Methods"
    }
}
